/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * Bookie - Martial Arts Private Lesson Scheduling SaaS API
 * OpenAPI spec version: 0.1.0
 */
import * as zod from "zod";

/**
 * @summary Health check
 */
export const HealthCheckResponse = zod.object({
  status: zod.string(),
});

/**
 * @summary Register a new user
 */
export const RegisterBody = zod.object({
  email: zod.string(),
  password: zod.string(),
  firstName: zod.string(),
  lastName: zod.string(),
  phone: zod.string().optional(),
  gymSlug: zod.string().optional(),
  gymId: zod.string().optional(),
  role: zod.enum(["STUDENT", "TRAINER", "ADMIN"]).optional(),
});

/**
 * @summary Login
 */
export const LoginBody = zod.object({
  email: zod.string(),
  password: zod.string(),
});

export const LoginResponse = zod.object({
  token: zod.string(),
  user: zod.object({
    id: zod.string(),
    email: zod.string(),
    firstName: zod.string(),
    lastName: zod.string(),
    role: zod.enum(["SUPERADMIN", "ADMIN", "TRAINER", "STUDENT"]),
    phone: zod.string().nullish(),
    avatarUrl: zod.string().nullish(),
    bio: zod.string().nullish(),
    specialties: zod.array(zod.string()).optional(),
    gymId: zod.string().nullish(),
    primaryLocationId: zod.string().nullish(),
    hourlyRate: zod.number().nullish(),
    gymSplitPct: zod.number().nullish(),
    canSetOwnRate: zod.boolean(),
    smsEnabled: zod.boolean(),
    emailEnabled: zod.boolean(),
    createdAt: zod.date(),
    stripeConnectAccountId: zod.string().nullish(),
    stripeConnectOnboarded: zod.boolean().optional(),
    stripeConnectPayoutsEnabled: zod.boolean().optional(),
    onboardingCompleted: zod.boolean().optional(),
  }),
});

/**
 * @summary Refresh access token
 */
export const RefreshTokenResponse = zod.object({
  token: zod.string(),
});

/**
 * @summary Logout
 */
export const LogoutResponse = zod.object({
  message: zod.string(),
});

/**
 * @summary Get current user profile
 */
export const GetMeResponse = zod.object({
  id: zod.string(),
  email: zod.string(),
  firstName: zod.string(),
  lastName: zod.string(),
  role: zod.enum(["SUPERADMIN", "ADMIN", "TRAINER", "STUDENT"]),
  phone: zod.string().nullish(),
  avatarUrl: zod.string().nullish(),
  bio: zod.string().nullish(),
  specialties: zod.array(zod.string()).optional(),
  gymId: zod.string().nullish(),
  primaryLocationId: zod.string().nullish(),
  hourlyRate: zod.number().nullish(),
  gymSplitPct: zod.number().nullish(),
  canSetOwnRate: zod.boolean(),
  smsEnabled: zod.boolean(),
  emailEnabled: zod.boolean(),
  createdAt: zod.date(),
  stripeConnectAccountId: zod.string().nullish(),
  stripeConnectOnboarded: zod.boolean().optional(),
  stripeConnectPayoutsEnabled: zod.boolean().optional(),
  onboardingCompleted: zod.boolean().optional(),
});

/**
 * @summary Self-serve gym registration
 */
export const OnboardGymBody = zod.object({
  gymName: zod.string(),
  slug: zod.string(),
  address: zod.string().optional(),
  city: zod.string().optional(),
  state: zod.string().optional(),
  zipCode: zod.string().optional(),
  timezone: zod.string().optional(),
  adminEmail: zod.string(),
  adminPassword: zod.string(),
  adminFirstName: zod.string(),
  adminLastName: zod.string(),
  adminPhone: zod.string().optional(),
});

/**
 * @summary Check gym slug availability
 */
export const CheckGymSlugParams = zod.object({
  slug: zod.coerce.string(),
});

export const CheckGymSlugResponse = zod.object({
  available: zod.boolean(),
  slug: zod.string(),
});

/**
 * @summary Mark student onboarding as complete
 */
export const CompleteStudentOnboardingResponse = zod.object({
  success: zod.boolean().optional(),
});

/**
 * @summary Public gym directory
 */
export const ListPublicGymsResponseItem = zod.object({
  id: zod.string(),
  name: zod.string(),
  slug: zod.string(),
  logoUrl: zod.string().nullish(),
  address: zod.string().nullish(),
  trainerCount: zod.number(),
  locationCount: zod.number(),
});
export const ListPublicGymsResponse = zod.array(ListPublicGymsResponseItem);

/**
 * @summary Public gym info with trainers and locations
 */
export const GetGymPublicParams = zod.object({
  slug: zod.coerce.string(),
});

export const GetGymPublicResponse = zod.object({
  gym: zod.object({
    id: zod.string(),
    name: zod.string(),
    slug: zod.string(),
    logoUrl: zod.string().nullish(),
    address: zod.string().nullish(),
    timezone: zod.string(),
    isActive: zod.boolean(),
    platformPlan: zod.enum(["FREE", "PREMIUM"]),
    platformFeePerSession: zod.number(),
    pricingMode: zod.enum(["GYM_DEFAULT", "TRAINER_SET", "HYBRID"]),
    defaultHourlyRate: zod.number().nullish(),
    defaultGymSplitPct: zod.number(),
    allowPerTrainerSplit: zod.boolean(),
    trainerMinRate: zod.number().nullish(),
    trainerMaxRate: zod.number().nullish(),
    cancellationWindowHrs: zod.number(),
    refundPctWithinWindow: zod.number(),
    lateRefundPct: zod.number(),
    brandingEnabled: zod.boolean(),
    brandPrimaryColor: zod.string().nullish(),
    brandAccentColor: zod.string().nullish(),
    brandAppName: zod.string().nullish(),
    brandFaviconUrl: zod.string().nullish(),
    brandLogoUrl: zod.string().nullish(),
    customDomain: zod.string().nullish(),
    scheduleSyncEnabled: zod.boolean(),
    aiAssistantName: zod.string().nullish(),
    aiAssistantGender: zod.string().nullish(),
    aiAssistantAvatarUrl: zod.string().nullish(),
    aiAssistantPersonalityPreset: zod.string().nullish(),
    aiAssistantPersonalityCustom: zod.string().nullish(),
    stripeConnectOnboarded: zod.boolean(),
    stripeConnectPayoutsEnabled: zod.boolean(),
    createdAt: zod.date(),
  }),
  trainers: zod.array(
    zod.object({
      id: zod.string(),
      email: zod.string(),
      firstName: zod.string(),
      lastName: zod.string(),
      phone: zod.string().nullish(),
      avatarUrl: zod.string().nullish(),
      bio: zod.string().nullish(),
      specialties: zod.array(zod.string()).optional(),
      hourlyRate: zod.number().nullish(),
      gymSplitPct: zod.number().nullish(),
      canSetOwnRate: zod.boolean(),
      primaryLocationId: zod.string().nullish(),
      locationIds: zod.array(zod.string()).optional(),
      avgRating: zod.number().nullish(),
      totalSessions: zod.number(),
      stripeConnectOnboarded: zod.boolean(),
      publicSlug: zod.string().nullish(),
      gender: zod.string().nullish(),
    }),
  ),
  locations: zod.array(
    zod.object({
      id: zod.string(),
      gymId: zod.string(),
      name: zod.string(),
      address: zod.string(),
      city: zod.string(),
      state: zod.string(),
      zipCode: zod.string().nullish(),
      phone: zod.string().nullish(),
      timezone: zod.string().nullish(),
      isActive: zod.boolean(),
      isPrimary: zod.boolean(),
      useSharedSchedule: zod.boolean(),
      availabilityMode: zod.enum(["CUSTOM"]),
      createdAt: zod.date(),
    }),
  ),
  packages: zod.array(
    zod.object({
      id: zod.string(),
      gymId: zod.string(),
      name: zod.string(),
      description: zod.string().nullish(),
      sessionCount: zod.number(),
      appliesToPrivates: zod.boolean(),
      appliesToGroupClasses: zod.boolean(),
      priceTotal: zod.number(),
      pricePerSession: zod.number(),
      savingsPct: zod.number().nullish(),
      isActive: zod.boolean(),
      expiryDays: zod.number().nullish(),
      createdAt: zod.date(),
    }),
  ),
  membershipPlans: zod.array(
    zod.object({
      id: zod.string(),
      gymId: zod.string(),
      name: zod.string(),
      description: zod.string().nullish(),
      priceMonthly: zod.number(),
      privateCredits: zod.number(),
      discountPct: zod.number(),
      isActive: zod.boolean(),
      createdAt: zod.date(),
    }),
  ),
  classes: zod
    .array(
      zod.object({
        id: zod.string(),
        gymId: zod.string(),
        locationId: zod.string().nullish(),
        trainerId: zod.string(),
        trainer: zod
          .object({
            id: zod.string(),
            firstName: zod.string(),
            lastName: zod.string(),
            avatarUrl: zod.string().nullish(),
            email: zod.string(),
          })
          .optional(),
        location: zod
          .object({
            id: zod.string(),
            gymId: zod.string(),
            name: zod.string(),
            address: zod.string(),
            city: zod.string(),
            state: zod.string(),
            zipCode: zod.string().nullish(),
            phone: zod.string().nullish(),
            timezone: zod.string().nullish(),
            isActive: zod.boolean(),
            isPrimary: zod.boolean(),
            useSharedSchedule: zod.boolean(),
            availabilityMode: zod.enum(["CUSTOM"]),
            createdAt: zod.date(),
          })
          .optional(),
        title: zod.string(),
        description: zod.string().nullish(),
        discipline: zod.string().nullish(),
        level: zod.string().nullish(),
        imageUrl: zod.string().nullish(),
        startTime: zod.date(),
        endTime: zod.date(),
        durationMinutes: zod.number(),
        isRecurring: zod.boolean(),
        capacityLimit: zod.number(),
        enrolledCount: zod.number(),
        waitlistCount: zod.number(),
        price: zod.number(),
        isFree: zod.boolean(),
        mode: zod.enum(["IN_PERSON", "VIDEO"]),
        status: zod.enum(["SCHEDULED", "CANCELLED", "COMPLETED"]),
        createdAt: zod.date(),
      }),
    )
    .optional(),
});

/**
 * @summary Update gym info
 */
export const UpdateGymParams = zod.object({
  id: zod.coerce.string(),
});

export const UpdateGymBody = zod.object({
  name: zod.string().optional(),
  logoUrl: zod.string().optional(),
  address: zod.string().optional(),
  timezone: zod.string().optional(),
});

export const UpdateGymResponse = zod.object({
  id: zod.string(),
  name: zod.string(),
  slug: zod.string(),
  logoUrl: zod.string().nullish(),
  address: zod.string().nullish(),
  timezone: zod.string(),
  isActive: zod.boolean(),
  platformPlan: zod.enum(["FREE", "PREMIUM"]),
  platformFeePerSession: zod.number(),
  pricingMode: zod.enum(["GYM_DEFAULT", "TRAINER_SET", "HYBRID"]),
  defaultHourlyRate: zod.number().nullish(),
  defaultGymSplitPct: zod.number(),
  allowPerTrainerSplit: zod.boolean(),
  trainerMinRate: zod.number().nullish(),
  trainerMaxRate: zod.number().nullish(),
  cancellationWindowHrs: zod.number(),
  refundPctWithinWindow: zod.number(),
  lateRefundPct: zod.number(),
  brandingEnabled: zod.boolean(),
  brandPrimaryColor: zod.string().nullish(),
  brandAccentColor: zod.string().nullish(),
  brandAppName: zod.string().nullish(),
  brandFaviconUrl: zod.string().nullish(),
  brandLogoUrl: zod.string().nullish(),
  customDomain: zod.string().nullish(),
  scheduleSyncEnabled: zod.boolean(),
  aiAssistantName: zod.string().nullish(),
  aiAssistantGender: zod.string().nullish(),
  aiAssistantAvatarUrl: zod.string().nullish(),
  aiAssistantPersonalityPreset: zod.string().nullish(),
  aiAssistantPersonalityCustom: zod.string().nullish(),
  stripeConnectOnboarded: zod.boolean(),
  stripeConnectPayoutsEnabled: zod.boolean(),
  createdAt: zod.date(),
});

/**
 * @summary Get gym pricing policy
 */
export const GetGymPricingPolicyParams = zod.object({
  id: zod.coerce.string(),
});

export const GetGymPricingPolicyResponse = zod.object({
  pricingMode: zod.enum(["GYM_DEFAULT", "TRAINER_SET", "HYBRID"]),
  defaultHourlyRate: zod.number().nullish(),
  defaultGymSplitPct: zod.number(),
  allowPerTrainerSplit: zod.boolean(),
  trainerMinRate: zod.number().nullish(),
  trainerMaxRate: zod.number().nullish(),
  allowTrainerPricing: zod.boolean().optional(),
});

/**
 * @summary Update gym pricing policy
 */
export const UpdateGymPricingPolicyParams = zod.object({
  id: zod.coerce.string(),
});

export const UpdateGymPricingPolicyBody = zod.object({
  pricingMode: zod.enum(["GYM_DEFAULT", "TRAINER_SET", "HYBRID"]),
  defaultHourlyRate: zod.number().nullish(),
  defaultGymSplitPct: zod.number(),
  allowPerTrainerSplit: zod.boolean(),
  trainerMinRate: zod.number().nullish(),
  trainerMaxRate: zod.number().nullish(),
  allowTrainerPricing: zod.boolean().optional(),
});

export const UpdateGymPricingPolicyResponse = zod.object({
  pricingMode: zod.enum(["GYM_DEFAULT", "TRAINER_SET", "HYBRID"]),
  defaultHourlyRate: zod.number().nullish(),
  defaultGymSplitPct: zod.number(),
  allowPerTrainerSplit: zod.boolean(),
  trainerMinRate: zod.number().nullish(),
  trainerMaxRate: zod.number().nullish(),
  allowTrainerPricing: zod.boolean().optional(),
});

/**
 * @summary Get cancellation policy
 */
export const GetGymCancellationPolicyParams = zod.object({
  id: zod.coerce.string(),
});

export const GetGymCancellationPolicyResponse = zod.object({
  cancellationWindowHrs: zod.number(),
  refundPctWithinWindow: zod.number(),
  lateRefundPct: zod.number(),
});

/**
 * @summary Update cancellation policy
 */
export const UpdateGymCancellationPolicyParams = zod.object({
  id: zod.coerce.string(),
});

export const UpdateGymCancellationPolicyBody = zod.object({
  cancellationWindowHrs: zod.number(),
  refundPctWithinWindow: zod.number(),
  lateRefundPct: zod.number(),
});

export const UpdateGymCancellationPolicyResponse = zod.object({
  cancellationWindowHrs: zod.number(),
  refundPctWithinWindow: zod.number(),
  lateRefundPct: zod.number(),
});

/**
 * @summary Get white-label branding config
 */
export const GetGymBrandingParams = zod.object({
  id: zod.coerce.string(),
});

export const GetGymBrandingResponse = zod.object({
  brandingEnabled: zod.boolean(),
  customDomain: zod.string().nullish(),
  brandPrimaryColor: zod.string().nullish(),
  brandAccentColor: zod.string().nullish(),
  brandFaviconUrl: zod.string().nullish(),
  brandAppName: zod.string().nullish(),
  brandLogoUrl: zod.string().nullish(),
});

/**
 * @summary Update white-label branding
 */
export const UpdateGymBrandingParams = zod.object({
  id: zod.coerce.string(),
});

export const UpdateGymBrandingBody = zod.object({
  brandingEnabled: zod.boolean(),
  customDomain: zod.string().nullish(),
  brandPrimaryColor: zod.string().nullish(),
  brandAccentColor: zod.string().nullish(),
  brandFaviconUrl: zod.string().nullish(),
  brandAppName: zod.string().nullish(),
  brandLogoUrl: zod.string().nullish(),
});

export const UpdateGymBrandingResponse = zod.object({
  brandingEnabled: zod.boolean(),
  customDomain: zod.string().nullish(),
  brandPrimaryColor: zod.string().nullish(),
  brandAccentColor: zod.string().nullish(),
  brandFaviconUrl: zod.string().nullish(),
  brandAppName: zod.string().nullish(),
  brandLogoUrl: zod.string().nullish(),
});

/**
 * @summary Get AI assistant config (public)
 */
export const GetGymAiAssistantPublicParams = zod.object({
  id: zod.coerce.string(),
});

export const GetGymAiAssistantPublicResponse = zod.object({
  name: zod.string(),
  gender: zod.enum(["male", "female", "neutral"]),
  avatarUrl: zod.string().nullish(),
  personalityPreset: zod.enum([
    "friendly",
    "professional",
    "motivational",
    "zen",
  ]),
  personalityCustom: zod.string().nullish(),
});

/**
 * @summary Get AI assistant config
 */
export const GetGymAiAssistantParams = zod.object({
  id: zod.coerce.string(),
});

export const GetGymAiAssistantResponse = zod.object({
  name: zod.string(),
  gender: zod.enum(["male", "female", "neutral"]),
  avatarUrl: zod.string().nullish(),
  personalityPreset: zod.enum([
    "friendly",
    "professional",
    "motivational",
    "zen",
  ]),
  personalityCustom: zod.string().nullish(),
});

/**
 * @summary Update AI assistant config
 */
export const UpdateGymAiAssistantParams = zod.object({
  id: zod.coerce.string(),
});

export const UpdateGymAiAssistantBody = zod.object({
  name: zod.string(),
  gender: zod.enum(["male", "female", "neutral"]),
  avatarUrl: zod.string().nullish(),
  personalityPreset: zod.enum([
    "friendly",
    "professional",
    "motivational",
    "zen",
  ]),
  personalityCustom: zod.string().nullish(),
});

export const UpdateGymAiAssistantResponse = zod.object({
  name: zod.string(),
  gender: zod.enum(["male", "female", "neutral"]),
  avatarUrl: zod.string().nullish(),
  personalityPreset: zod.enum([
    "friendly",
    "professional",
    "motivational",
    "zen",
  ]),
  personalityCustom: zod.string().nullish(),
});

/**
 * @summary List gym locations
 */
export const ListLocationsParams = zod.object({
  gymId: zod.coerce.string(),
});

export const ListLocationsResponseItem = zod.object({
  id: zod.string(),
  gymId: zod.string(),
  name: zod.string(),
  address: zod.string(),
  city: zod.string(),
  state: zod.string(),
  zipCode: zod.string().nullish(),
  phone: zod.string().nullish(),
  timezone: zod.string().nullish(),
  isActive: zod.boolean(),
  isPrimary: zod.boolean(),
  useSharedSchedule: zod.boolean(),
  availabilityMode: zod.enum(["CUSTOM"]),
  createdAt: zod.date(),
});
export const ListLocationsResponse = zod.array(ListLocationsResponseItem);

/**
 * @summary Add a location
 */
export const CreateLocationBody = zod.object({
  gymId: zod.string(),
  name: zod.string(),
  address: zod.string(),
  city: zod.string(),
  state: zod.string(),
  zipCode: zod.string().optional(),
  phone: zod.string().optional(),
  timezone: zod.string().optional(),
  isPrimary: zod.boolean().optional(),
});

/**
 * @summary Update location
 */
export const UpdateLocationParams = zod.object({
  id: zod.coerce.string(),
});

export const UpdateLocationBody = zod.object({
  name: zod.string().optional(),
  address: zod.string().optional(),
  city: zod.string().optional(),
  state: zod.string().optional(),
  zipCode: zod.string().optional(),
  phone: zod.string().optional(),
  timezone: zod.string().optional(),
  isPrimary: zod.boolean().optional(),
  useSharedSchedule: zod.boolean().optional(),
  availabilityMode: zod.enum(["CUSTOM"]).optional(),
});

export const UpdateLocationResponse = zod.object({
  id: zod.string(),
  gymId: zod.string(),
  name: zod.string(),
  address: zod.string(),
  city: zod.string(),
  state: zod.string(),
  zipCode: zod.string().nullish(),
  phone: zod.string().nullish(),
  timezone: zod.string().nullish(),
  isActive: zod.boolean(),
  isPrimary: zod.boolean(),
  useSharedSchedule: zod.boolean(),
  availabilityMode: zod.enum(["CUSTOM"]),
  createdAt: zod.date(),
});

/**
 * @summary Toggle location active status
 */
export const ToggleLocationActiveParams = zod.object({
  id: zod.coerce.string(),
});

export const ToggleLocationActiveBody = zod.object({
  isActive: zod.boolean(),
});

export const ToggleLocationActiveResponse = zod.object({
  id: zod.string(),
  gymId: zod.string(),
  name: zod.string(),
  address: zod.string(),
  city: zod.string(),
  state: zod.string(),
  zipCode: zod.string().nullish(),
  phone: zod.string().nullish(),
  timezone: zod.string().nullish(),
  isActive: zod.boolean(),
  isPrimary: zod.boolean(),
  useSharedSchedule: zod.boolean(),
  availabilityMode: zod.enum(["CUSTOM"]),
  createdAt: zod.date(),
});

/**
 * @summary List availability blocks for a location
 */
export const ListLocationAvailabilityParams = zod.object({
  locationId: zod.coerce.string(),
});

export const ListLocationAvailabilityResponseItem = zod.object({
  id: zod.string(),
  locationId: zod.string(),
  dayOfWeek: zod.number(),
  startTime: zod.string(),
  endTime: zod.string(),
  isActive: zod.boolean(),
});
export const ListLocationAvailabilityResponse = zod.array(
  ListLocationAvailabilityResponseItem,
);

/**
 * @summary Add availability block to a location
 */
export const CreateLocationAvailabilityParams = zod.object({
  locationId: zod.coerce.string(),
});

export const CreateLocationAvailabilityBody = zod.object({
  dayOfWeek: zod.number(),
  startTime: zod.string(),
  endTime: zod.string(),
});

/**
 * @summary Update a location availability block
 */
export const UpdateLocationAvailabilityParams = zod.object({
  locationId: zod.coerce.string(),
  id: zod.coerce.string(),
});

export const UpdateLocationAvailabilityBody = zod.object({
  dayOfWeek: zod.number().optional(),
  startTime: zod.string().optional(),
  endTime: zod.string().optional(),
  isActive: zod.boolean().optional(),
});

export const UpdateLocationAvailabilityResponse = zod.object({
  id: zod.string(),
  locationId: zod.string(),
  dayOfWeek: zod.number(),
  startTime: zod.string(),
  endTime: zod.string(),
  isActive: zod.boolean(),
});

/**
 * @summary Delete a location availability block
 */
export const DeleteLocationAvailabilityParams = zod.object({
  locationId: zod.coerce.string(),
  id: zod.coerce.string(),
});

/**
 * @summary Copy schedule from source location to all synced locations
 */
export const CopyLocationScheduleParams = zod.object({
  locationId: zod.coerce.string(),
});

export const CopyLocationScheduleResponse = zod.object({
  copiedToLocations: zod.number(),
  blocksPerLocation: zod.number(),
});

/**
 * @summary Get schedule sync settings for a gym
 */
export const GetGymScheduleSyncParams = zod.object({
  id: zod.coerce.string(),
});

export const GetGymScheduleSyncResponse = zod.object({
  scheduleSyncEnabled: zod.boolean(),
});

/**
 * @summary Toggle schedule sync for a gym
 */
export const UpdateGymScheduleSyncParams = zod.object({
  id: zod.coerce.string(),
});

export const UpdateGymScheduleSyncBody = zod.object({
  scheduleSyncEnabled: zod.boolean(),
});

export const UpdateGymScheduleSyncResponse = zod.object({
  scheduleSyncEnabled: zod.boolean(),
});

/**
 * @summary List trainers across all gyms
 */
export const ListPublicTrainersQueryParams = zod.object({
  area: zod.coerce.string().optional(),
});

export const ListPublicTrainersResponseItem = zod.object({
  id: zod.string(),
  firstName: zod.string(),
  lastName: zod.string(),
  phone: zod.string().nullish(),
  avatarUrl: zod.string().nullish(),
  bio: zod.string().nullish(),
  specialties: zod.array(zod.string()).optional(),
  hourlyRate: zod.number().nullish(),
  gymSplitPct: zod.number().nullish(),
  canSetOwnRate: zod.boolean(),
  primaryLocationId: zod.string().nullish(),
  avgRating: zod.number().nullish(),
  totalSessions: zod.number(),
  stripeConnectOnboarded: zod.boolean(),
  gymId: zod.string().nullish(),
  gymName: zod.string().nullish(),
  gymSlug: zod.string().nullish(),
  publicSlug: zod.string().nullish(),
});
export const ListPublicTrainersResponse = zod.array(
  ListPublicTrainersResponseItem,
);

/**
 * @summary Get public trainer profile by slug
 */
export const GetTrainerBySlugParams = zod.object({
  slug: zod.coerce.string(),
});

export const GetTrainerBySlugResponse = zod.object({
  id: zod.string(),
  firstName: zod.string(),
  lastName: zod.string(),
  phone: zod.string().nullish(),
  avatarUrl: zod.string().nullish(),
  bio: zod.string().nullish(),
  specialties: zod.array(zod.string()).optional(),
  hourlyRate: zod.number().nullish(),
  gymSplitPct: zod.number().nullish(),
  canSetOwnRate: zod.boolean(),
  primaryLocationId: zod.string().nullish(),
  avgRating: zod.number().nullish(),
  totalSessions: zod.number(),
  stripeConnectOnboarded: zod.boolean(),
  certifications: zod.array(zod.string()),
  yearsExperience: zod.number().nullish(),
  introVideoUrl: zod.string().nullish(),
  publicSlug: zod.string().nullish(),
  gymName: zod.string().nullish(),
  gymSlug: zod.string().nullish(),
  gymId: zod.string().nullish(),
});

/**
 * @summary List trainers for a gym
 */
export const ListTrainersParams = zod.object({
  gymId: zod.coerce.string(),
});

export const ListTrainersQueryParams = zod.object({
  locationId: zod.coerce.string().optional(),
});

export const ListTrainersResponseItem = zod.object({
  id: zod.string(),
  email: zod.string(),
  firstName: zod.string(),
  lastName: zod.string(),
  phone: zod.string().nullish(),
  avatarUrl: zod.string().nullish(),
  bio: zod.string().nullish(),
  specialties: zod.array(zod.string()).optional(),
  hourlyRate: zod.number().nullish(),
  gymSplitPct: zod.number().nullish(),
  canSetOwnRate: zod.boolean(),
  primaryLocationId: zod.string().nullish(),
  locationIds: zod.array(zod.string()).optional(),
  avgRating: zod.number().nullish(),
  totalSessions: zod.number(),
  stripeConnectOnboarded: zod.boolean(),
  publicSlug: zod.string().nullish(),
  gender: zod.string().nullish(),
});
export const ListTrainersResponse = zod.array(ListTrainersResponseItem);

/**
 * @summary Get trainer profile
 */
export const GetTrainerParams = zod.object({
  id: zod.coerce.string(),
});

export const GetTrainerResponse = zod.object({
  id: zod.string(),
  email: zod.string(),
  firstName: zod.string(),
  lastName: zod.string(),
  phone: zod.string().nullish(),
  avatarUrl: zod.string().nullish(),
  bio: zod.string().nullish(),
  specialties: zod.array(zod.string()).optional(),
  hourlyRate: zod.number().nullish(),
  gymSplitPct: zod.number().nullish(),
  canSetOwnRate: zod.boolean(),
  primaryLocationId: zod.string().nullish(),
  locationIds: zod.array(zod.string()).optional(),
  avgRating: zod.number().nullish(),
  totalSessions: zod.number(),
  stripeConnectOnboarded: zod.boolean(),
  publicSlug: zod.string().nullish(),
  gender: zod.string().nullish(),
});

/**
 * @summary Remove a trainer from the gym (admin)
 */
export const DeleteTrainerParams = zod.object({
  id: zod.coerce.string(),
});

export const DeleteTrainerResponse = zod.object({
  success: zod.boolean().optional(),
});

/**
 * @summary Create trainer (admin)
 */
export const CreateTrainerBody = zod.object({
  email: zod.string(),
  password: zod.string(),
  firstName: zod.string(),
  lastName: zod.string(),
  phone: zod.string().optional(),
  bio: zod.string().optional(),
  specialties: zod.array(zod.string()).optional(),
  gymId: zod.string(),
  primaryLocationId: zod.string().optional(),
  hourlyRate: zod.number().optional(),
  gymSplitPct: zod.number().optional(),
  canSetOwnRate: zod.boolean().optional(),
});

/**
 * @summary Update trainer settings (admin)
 */
export const UpdateTrainerAdminSettingsParams = zod.object({
  id: zod.coerce.string(),
});

export const UpdateTrainerAdminSettingsBody = zod.object({
  hourlyRate: zod.number().optional(),
  gymSplitPct: zod.number().optional(),
  canSetOwnRate: zod.boolean().optional(),
  primaryLocationId: zod.string().optional(),
  locationIds: zod.array(zod.string()).optional(),
  gender: zod.string().optional(),
});

export const UpdateTrainerAdminSettingsResponse = zod.object({
  id: zod.string(),
  email: zod.string(),
  firstName: zod.string(),
  lastName: zod.string(),
  phone: zod.string().nullish(),
  avatarUrl: zod.string().nullish(),
  bio: zod.string().nullish(),
  specialties: zod.array(zod.string()).optional(),
  hourlyRate: zod.number().nullish(),
  gymSplitPct: zod.number().nullish(),
  canSetOwnRate: zod.boolean(),
  primaryLocationId: zod.string().nullish(),
  locationIds: zod.array(zod.string()).optional(),
  avgRating: zod.number().nullish(),
  totalSessions: zod.number(),
  stripeConnectOnboarded: zod.boolean(),
  publicSlug: zod.string().nullish(),
  gender: zod.string().nullish(),
});

/**
 * @summary Get trainer location assignments
 */
export const GetTrainerLocationsParams = zod.object({
  id: zod.coerce.string(),
});

export const GetTrainerLocationsResponseItem = zod.string();
export const GetTrainerLocationsResponse = zod.array(
  GetTrainerLocationsResponseItem,
);

/**
 * @summary Update trainer location assignments
 */
export const UpdateTrainerLocationsParams = zod.object({
  id: zod.coerce.string(),
});

export const UpdateTrainerLocationsBody = zod.object({
  locationIds: zod.array(zod.string()),
});

export const UpdateTrainerLocationsResponseItem = zod.string();
export const UpdateTrainerLocationsResponse = zod.array(
  UpdateTrainerLocationsResponseItem,
);

/**
 * @summary Get students that have had sessions with this trainer
 */
export const GetTrainerStudentsParams = zod.object({
  id: zod.coerce.string(),
});

export const GetTrainerStudentsResponseItem = zod.object({
  id: zod.string(),
  firstName: zod.string(),
  lastName: zod.string(),
  email: zod.string(),
  avatarUrl: zod.string().nullish(),
});
export const GetTrainerStudentsResponse = zod.array(
  GetTrainerStudentsResponseItem,
);

/**
 * @summary List per-client rate overrides for a trainer
 */
export const GetTrainerClientRatesParams = zod.object({
  id: zod.coerce.string(),
});

export const GetTrainerClientRatesResponseItem = zod.object({
  id: zod.string(),
  trainerId: zod.string(),
  studentId: zod.string(),
  gymId: zod.string(),
  hourlyRate: zod.number(),
  createdAt: zod.date().optional(),
  updatedAt: zod.date().optional(),
  student: zod
    .object({
      id: zod.string().optional(),
      firstName: zod.string().optional(),
      lastName: zod.string().optional(),
      email: zod.string().optional(),
      avatarUrl: zod.string().nullish(),
    })
    .nullish(),
});
export const GetTrainerClientRatesResponse = zod.array(
  GetTrainerClientRatesResponseItem,
);

/**
 * @summary Create or update a per-client rate override
 */
export const CreateTrainerClientRateParams = zod.object({
  id: zod.coerce.string(),
});

export const CreateTrainerClientRateBody = zod.object({
  studentId: zod.string(),
  hourlyRate: zod.number(),
});

export const CreateTrainerClientRateResponse = zod.object({
  id: zod.string(),
  trainerId: zod.string(),
  studentId: zod.string(),
  gymId: zod.string(),
  hourlyRate: zod.number(),
  createdAt: zod.date().optional(),
  updatedAt: zod.date().optional(),
  student: zod
    .object({
      id: zod.string().optional(),
      firstName: zod.string().optional(),
      lastName: zod.string().optional(),
      email: zod.string().optional(),
      avatarUrl: zod.string().nullish(),
    })
    .nullish(),
});

/**
 * @summary Delete a per-client rate override
 */
export const DeleteTrainerClientRateParams = zod.object({
  id: zod.coerce.string(),
  rateId: zod.coerce.string(),
});

export const DeleteTrainerClientRateResponse = zod.object({
  success: zod.boolean().optional(),
});

/**
 * @summary Trainer self-set rate
 */
export const UpdateTrainerRateParams = zod.object({
  id: zod.coerce.string(),
});

export const UpdateTrainerRateBody = zod.object({
  hourlyRate: zod.number(),
});

export const UpdateTrainerRateResponse = zod.object({
  id: zod.string(),
  email: zod.string(),
  firstName: zod.string(),
  lastName: zod.string(),
  phone: zod.string().nullish(),
  avatarUrl: zod.string().nullish(),
  bio: zod.string().nullish(),
  specialties: zod.array(zod.string()).optional(),
  hourlyRate: zod.number().nullish(),
  gymSplitPct: zod.number().nullish(),
  canSetOwnRate: zod.boolean(),
  primaryLocationId: zod.string().nullish(),
  locationIds: zod.array(zod.string()).optional(),
  avgRating: zod.number().nullish(),
  totalSessions: zod.number(),
  stripeConnectOnboarded: zod.boolean(),
  publicSlug: zod.string().nullish(),
  gender: zod.string().nullish(),
});

/**
 * @summary Update trainer profile
 */
export const UpdateTrainerProfileParams = zod.object({
  id: zod.coerce.string(),
});

export const UpdateTrainerProfileBody = zod.object({
  bio: zod.string().optional(),
  avatarUrl: zod.string().optional(),
  specialties: zod.array(zod.string()).optional(),
  phone: zod.string().optional(),
  gender: zod.string().optional(),
});

export const UpdateTrainerProfileResponse = zod.object({
  id: zod.string(),
  email: zod.string(),
  firstName: zod.string(),
  lastName: zod.string(),
  phone: zod.string().nullish(),
  avatarUrl: zod.string().nullish(),
  bio: zod.string().nullish(),
  specialties: zod.array(zod.string()).optional(),
  hourlyRate: zod.number().nullish(),
  gymSplitPct: zod.number().nullish(),
  canSetOwnRate: zod.boolean(),
  primaryLocationId: zod.string().nullish(),
  locationIds: zod.array(zod.string()).optional(),
  avgRating: zod.number().nullish(),
  totalSessions: zod.number(),
  stripeConnectOnboarded: zod.boolean(),
  publicSlug: zod.string().nullish(),
  gender: zod.string().nullish(),
});

/**
 * @summary Search trainers with scheduling assistant filters
 */
export const SearchTrainersAssistantBody = zod.object({
  gymId: zod
    .string()
    .optional()
    .describe("Deprecated - gym is derived from authenticated user"),
  specialty: zod.string().optional(),
  genderPreference: zod.string().optional(),
  dayPreferences: zod.array(zod.number()).optional(),
  timePreference: zod.string().optional(),
});

export const SearchTrainersAssistantResponse = zod.object({
  matches: zod.array(
    zod.object({
      id: zod.string(),
      firstName: zod.string(),
      lastName: zod.string(),
      avatarUrl: zod.string().nullish(),
      bio: zod.string().nullish(),
      specialties: zod.array(zod.string()).optional(),
      hourlyRate: zod.number().nullish(),
      avgRating: zod.number().nullish(),
      totalSessions: zod.number(),
      gender: zod.string().nullish(),
      availableSlots: zod
        .array(
          zod.object({
            start: zod.date(),
            end: zod.date(),
            trainerId: zod.string(),
            locationId: zod.string().nullish(),
          }),
        )
        .optional(),
      totalAvailableSlots: zod.number(),
    }),
  ),
  otherTrainers: zod.array(
    zod.object({
      id: zod.string(),
      firstName: zod.string(),
      lastName: zod.string(),
      avatarUrl: zod.string().nullish(),
      bio: zod.string().nullish(),
      specialties: zod.array(zod.string()).optional(),
      hourlyRate: zod.number().nullish(),
      avgRating: zod.number().nullish(),
      totalSessions: zod.number(),
      gender: zod.string().nullish(),
      availableSlots: zod
        .array(
          zod.object({
            start: zod.date(),
            end: zod.date(),
            trainerId: zod.string(),
            locationId: zod.string().nullish(),
          }),
        )
        .optional(),
      totalAvailableSlots: zod.number(),
    }),
  ),
  suggestions: zod.array(zod.string()),
});

/**
 * @summary Invite a trainer (admin)
 */
export const InviteTrainerBody = zod.object({
  firstName: zod.string(),
  lastName: zod.string(),
  email: zod.string(),
  phone: zod.string().optional(),
});

/**
 * @summary List trainer invites for gym (admin)
 */
export const ListTrainerInvitesResponseItem = zod.object({
  id: zod.string(),
  gymId: zod.string(),
  invitedBy: zod.string(),
  recipientFirstName: zod.string(),
  recipientLastName: zod.string(),
  recipientEmail: zod.string(),
  recipientPhone: zod.string().nullish(),
  token: zod.string(),
  status: zod.enum(["PENDING", "ACCEPTED", "EXPIRED"]),
  acceptedByUserId: zod.string().nullish(),
  emailDelivered: zod.boolean().nullish(),
  smsDelivered: zod.boolean().nullish(),
  sentAt: zod.date(),
  acceptedAt: zod.date().nullish(),
  expiresAt: zod.date(),
  createdAt: zod.date(),
});
export const ListTrainerInvitesResponse = zod.array(
  ListTrainerInvitesResponseItem,
);

/**
 * @summary Get trainer invite details (public)
 */
export const GetTrainerInviteParams = zod.object({
  token: zod.coerce.string(),
});

export const GetTrainerInviteResponse = zod.object({
  firstName: zod.string(),
  lastName: zod.string(),
  email: zod.string(),
  phone: zod.string().nullish(),
  gymName: zod.string(),
  gymId: zod.string(),
  inviterName: zod.string().nullish(),
});

/**
 * @summary Cancel a pending trainer invite (admin)
 */
export const CancelTrainerInviteParams = zod.object({
  token: zod.coerce.string(),
});

export const CancelTrainerInviteResponse = zod.object({
  success: zod.boolean().optional(),
});

/**
 * @summary Accept trainer invite and create account
 */
export const AcceptTrainerInviteParams = zod.object({
  token: zod.coerce.string(),
});

export const AcceptTrainerInviteBody = zod.object({
  password: zod.string(),
  bio: zod.string().optional(),
  specialties: zod.array(zod.string()).optional(),
  certifications: zod.array(zod.string()).optional(),
  yearsExperience: zod.number().optional(),
});

/**
 * @summary Resend a trainer invite (admin)
 */
export const ResendTrainerInviteParams = zod.object({
  token: zod.coerce.string(),
});

export const ResendTrainerInviteResponse = zod.object({
  id: zod.string(),
  gymId: zod.string(),
  invitedBy: zod.string(),
  recipientFirstName: zod.string(),
  recipientLastName: zod.string(),
  recipientEmail: zod.string(),
  recipientPhone: zod.string().nullish(),
  token: zod.string(),
  status: zod.enum(["PENDING", "ACCEPTED", "EXPIRED"]),
  acceptedByUserId: zod.string().nullish(),
  emailDelivered: zod.boolean().nullish(),
  smsDelivered: zod.boolean().nullish(),
  sentAt: zod.date(),
  acceptedAt: zod.date().nullish(),
  expiresAt: zod.date(),
  createdAt: zod.date(),
});

/**
 * @summary Generate new Stripe Connect onboarding link
 */
export const RefreshStripeConnectResponse = zod.object({
  url: zod.string(),
});

/**
 * @summary Check and mark Stripe Connect onboarding complete
 */
export const CompleteStripeConnectResponse = zod.object({
  onboarded: zod.boolean(),
  payoutsEnabled: zod.boolean(),
});

/**
 * @summary Get trainer weekly availability
 */
export const GetTrainerAvailabilityParams = zod.object({
  trainerId: zod.coerce.string(),
});

export const GetTrainerAvailabilityQueryParams = zod.object({
  locationId: zod.coerce.string().optional(),
});

export const GetTrainerAvailabilityResponseItem = zod.object({
  id: zod.string(),
  trainerId: zod.string(),
  gymId: zod.string(),
  locationId: zod.string().nullish(),
  dayOfWeek: zod.number(),
  startTime: zod.string(),
  endTime: zod.string(),
  isActive: zod.boolean(),
});
export const GetTrainerAvailabilityResponse = zod.array(
  GetTrainerAvailabilityResponseItem,
);

/**
 * @summary Add availability block
 */
export const CreateAvailabilityBody = zod.object({
  trainerId: zod.string(),
  gymId: zod.string(),
  locationId: zod.string().optional(),
  dayOfWeek: zod.number(),
  startTime: zod.string(),
  endTime: zod.string(),
});

/**
 * @summary Update availability block
 */
export const UpdateAvailabilityParams = zod.object({
  id: zod.coerce.string(),
});

export const UpdateAvailabilityBody = zod.object({
  dayOfWeek: zod.number().optional(),
  startTime: zod.string().optional(),
  endTime: zod.string().optional(),
  locationId: zod.string().optional(),
  isActive: zod.boolean().optional(),
});

export const UpdateAvailabilityResponse = zod.object({
  id: zod.string(),
  trainerId: zod.string(),
  gymId: zod.string(),
  locationId: zod.string().nullish(),
  dayOfWeek: zod.number(),
  startTime: zod.string(),
  endTime: zod.string(),
  isActive: zod.boolean(),
});

/**
 * @summary Delete availability block
 */
export const DeleteAvailabilityParams = zod.object({
  id: zod.coerce.string(),
});

/**
 * @summary Set availability across multiple locations
 */
export const BulkSetAvailabilityBody = zod.object({
  trainerId: zod.string(),
  locationIds: zod.array(zod.string()),
  slots: zod.array(
    zod.object({
      dayOfWeek: zod.number(),
      startTime: zod.string(),
      endTime: zod.string(),
    }),
  ),
});

/**
 * @summary Get available time slots for next 30 days
 */
export const GetOpenSlotsParams = zod.object({
  trainerId: zod.coerce.string(),
});

export const GetOpenSlotsQueryParams = zod.object({
  locationId: zod.coerce.string().optional(),
});

export const GetOpenSlotsResponseItem = zod.object({
  start: zod.date(),
  end: zod.date(),
  trainerId: zod.string(),
  locationId: zod.string().nullish(),
});
export const GetOpenSlotsResponse = zod.array(GetOpenSlotsResponseItem);

/**
 * @summary Join slot waitlist for a trainer
 */
export const JoinSlotWaitlistParams = zod.object({
  trainerId: zod.coerce.string(),
});

export const joinSlotWaitlistBodyDayOfWeekMin = 0;
export const joinSlotWaitlistBodyDayOfWeekMax = 6;

export const JoinSlotWaitlistBody = zod.object({
  dayOfWeek: zod
    .number()
    .min(joinSlotWaitlistBodyDayOfWeekMin)
    .max(joinSlotWaitlistBodyDayOfWeekMax),
  timeSlot: zod.string(),
});

/**
 * @summary Leave slot waitlist
 */
export const LeaveSlotWaitlistParams = zod.object({
  trainerId: zod.coerce.string(),
  entryId: zod.coerce.string(),
});

/**
 * @summary Get active slot waitlist entries for current user
 */
export const GetMySlotWaitlistResponseItem = zod.object({
  id: zod.string(),
  trainerId: zod.string(),
  studentId: zod.string(),
  gymId: zod.string(),
  dayOfWeek: zod.number(),
  timeSlot: zod.string(),
  isActive: zod.boolean(),
  createdAt: zod.date(),
  trainer: zod
    .object({
      firstName: zod.string(),
      lastName: zod.string(),
      avatarUrl: zod.string().nullish(),
    })
    .optional(),
});
export const GetMySlotWaitlistResponse = zod.array(
  GetMySlotWaitlistResponseItem,
);

/**
 * @summary Get trainer's client list
 */
export const GetTrainerClientsResponseItem = zod.object({
  id: zod.string(),
  studentId: zod.string(),
  firstName: zod.string(),
  lastName: zod.string(),
  email: zod.string(),
  phone: zod.string().nullish(),
  avatarUrl: zod.string().nullish(),
  smsEnabled: zod.boolean(),
  hasPhone: zod.boolean(),
  addedAt: zod.string(),
  totalSessions: zod.number(),
  lastSessionDate: zod.string().nullish(),
});
export const GetTrainerClientsResponse = zod.array(
  GetTrainerClientsResponseItem,
);

/**
 * @summary Send SMS to a client
 */
export const SendClientSmsParams = zod.object({
  clientId: zod.coerce.string(),
});

export const SendClientSmsBody = zod.object({
  message: zod.string(),
});

export const SendClientSmsResponse = zod.object({
  sent: zod.boolean(),
  errorDetail: zod.string().nullish(),
  friendlyMessage: zod.string().nullish(),
});

/**
 * @summary Get trainer's message templates
 */
export const GetTrainerMessageTemplatesResponseItem = zod.object({
  id: zod.string(),
  trainerId: zod.string(),
  context: zod.string(),
  title: zod.string(),
  body: zod.string(),
  isDefault: zod.boolean(),
  createdAt: zod.string(),
  updatedAt: zod.string(),
});
export const GetTrainerMessageTemplatesResponse = zod.array(
  GetTrainerMessageTemplatesResponseItem,
);

/**
 * @summary Create a message template
 */
export const CreateTrainerMessageTemplateBody = zod.object({
  title: zod.string(),
  body: zod.string(),
  context: zod.enum(["REJECT", "AMEND", "CANCEL", "GENERAL"]).optional(),
});

/**
 * @summary Update a message template
 */
export const UpdateTrainerMessageTemplateParams = zod.object({
  id: zod.coerce.string(),
});

export const UpdateTrainerMessageTemplateBody = zod.object({
  title: zod.string().optional(),
  body: zod.string().optional(),
  context: zod.enum(["REJECT", "AMEND", "CANCEL", "GENERAL"]).optional(),
});

export const UpdateTrainerMessageTemplateResponse = zod.object({
  id: zod.string(),
  trainerId: zod.string(),
  context: zod.string(),
  title: zod.string(),
  body: zod.string(),
  isDefault: zod.boolean(),
  createdAt: zod.string(),
  updatedAt: zod.string(),
});

/**
 * @summary Delete a message template
 */
export const DeleteTrainerMessageTemplateParams = zod.object({
  id: zod.coerce.string(),
});

export const DeleteTrainerMessageTemplateResponse = zod.object({
  success: zod.boolean(),
});

/**
 * @summary Book a private session
 */
export const CreateSessionBody = zod.object({
  trainerId: zod.string(),
  gymId: zod.string(),
  locationId: zod.string().optional(),
  proposedStart: zod.date(),
  durationMinutes: zod.number(),
  mode: zod.enum(["IN_PERSON", "VIDEO"]).optional(),
  paymentType: zod.enum(["SINGLE", "PACKAGE", "MEMBERSHIP"]).optional(),
  packagePurchaseId: zod.string().optional(),
  membershipId: zod.string().optional(),
});

/**
 * @summary Get own sessions
 */
export const GetMySessionsQueryParams = zod.object({
  status: zod.coerce.string().optional(),
});

export const GetMySessionsResponseItem = zod.object({
  id: zod.string(),
  gymId: zod.string(),
  locationId: zod.string().nullish(),
  trainerId: zod.string(),
  studentId: zod.string(),
  trainer: zod
    .object({
      id: zod.string(),
      firstName: zod.string(),
      lastName: zod.string(),
      avatarUrl: zod.string().nullish(),
      email: zod.string(),
    })
    .optional(),
  student: zod
    .object({
      id: zod.string(),
      firstName: zod.string(),
      lastName: zod.string(),
      avatarUrl: zod.string().nullish(),
      email: zod.string(),
    })
    .optional(),
  location: zod
    .object({
      id: zod.string(),
      gymId: zod.string(),
      name: zod.string(),
      address: zod.string(),
      city: zod.string(),
      state: zod.string(),
      zipCode: zod.string().nullish(),
      phone: zod.string().nullish(),
      timezone: zod.string().nullish(),
      isActive: zod.boolean(),
      isPrimary: zod.boolean(),
      useSharedSchedule: zod.boolean(),
      availabilityMode: zod.enum(["CUSTOM"]),
      createdAt: zod.date(),
    })
    .optional(),
  proposedStart: zod.date(),
  proposedEnd: zod.date(),
  confirmedStart: zod.date().nullish(),
  confirmedEnd: zod.date().nullish(),
  durationMinutes: zod.number(),
  mode: zod.enum(["IN_PERSON", "VIDEO"]),
  dailyRoomUrl: zod.string().nullish(),
  rateSnapshot: zod.number(),
  splitSnapshot: zod.number(),
  platformFeeSnapshot: zod.number(),
  priceTotal: zod.number(),
  platformFee: zod.number(),
  netAfterPlatform: zod.number(),
  gymRevenue: zod.number(),
  trainerPayout: zod.number(),
  paymentType: zod.enum(["SINGLE", "PACKAGE", "MEMBERSHIP"]),
  status: zod.enum([
    "PENDING",
    "CONFIRMED",
    "AMENDMENT_PENDING",
    "REJECTED",
    "CANCELLED",
    "COMPLETED",
  ]),
  statusNote: zod.string().nullish(),
  amendedStart: zod.date().nullish(),
  amendedEnd: zod.date().nullish(),
  amendedBy: zod.string().nullish(),
  amendStatus: zod.enum(["PROPOSED", "ACCEPTED", "REJECTED"]).nullish(),
  rating: zod
    .object({
      id: zod.string(),
      sessionId: zod.string(),
      trainerId: zod.string(),
      studentId: zod.string(),
      score: zod.number(),
      comment: zod.string().nullish(),
      createdAt: zod.date(),
    })
    .optional(),
  paidAt: zod.date().nullish(),
  createdAt: zod.date(),
});
export const GetMySessionsResponse = zod.array(GetMySessionsResponseItem);

/**
 * @summary All gym sessions (admin)
 */
export const GetGymSessionsParams = zod.object({
  gymId: zod.coerce.string(),
});

export const GetGymSessionsQueryParams = zod.object({
  status: zod.coerce.string().optional(),
  locationId: zod.coerce.string().optional(),
});

export const GetGymSessionsResponseItem = zod.object({
  id: zod.string(),
  gymId: zod.string(),
  locationId: zod.string().nullish(),
  trainerId: zod.string(),
  studentId: zod.string(),
  trainer: zod
    .object({
      id: zod.string(),
      firstName: zod.string(),
      lastName: zod.string(),
      avatarUrl: zod.string().nullish(),
      email: zod.string(),
    })
    .optional(),
  student: zod
    .object({
      id: zod.string(),
      firstName: zod.string(),
      lastName: zod.string(),
      avatarUrl: zod.string().nullish(),
      email: zod.string(),
    })
    .optional(),
  location: zod
    .object({
      id: zod.string(),
      gymId: zod.string(),
      name: zod.string(),
      address: zod.string(),
      city: zod.string(),
      state: zod.string(),
      zipCode: zod.string().nullish(),
      phone: zod.string().nullish(),
      timezone: zod.string().nullish(),
      isActive: zod.boolean(),
      isPrimary: zod.boolean(),
      useSharedSchedule: zod.boolean(),
      availabilityMode: zod.enum(["CUSTOM"]),
      createdAt: zod.date(),
    })
    .optional(),
  proposedStart: zod.date(),
  proposedEnd: zod.date(),
  confirmedStart: zod.date().nullish(),
  confirmedEnd: zod.date().nullish(),
  durationMinutes: zod.number(),
  mode: zod.enum(["IN_PERSON", "VIDEO"]),
  dailyRoomUrl: zod.string().nullish(),
  rateSnapshot: zod.number(),
  splitSnapshot: zod.number(),
  platformFeeSnapshot: zod.number(),
  priceTotal: zod.number(),
  platformFee: zod.number(),
  netAfterPlatform: zod.number(),
  gymRevenue: zod.number(),
  trainerPayout: zod.number(),
  paymentType: zod.enum(["SINGLE", "PACKAGE", "MEMBERSHIP"]),
  status: zod.enum([
    "PENDING",
    "CONFIRMED",
    "AMENDMENT_PENDING",
    "REJECTED",
    "CANCELLED",
    "COMPLETED",
  ]),
  statusNote: zod.string().nullish(),
  amendedStart: zod.date().nullish(),
  amendedEnd: zod.date().nullish(),
  amendedBy: zod.string().nullish(),
  amendStatus: zod.enum(["PROPOSED", "ACCEPTED", "REJECTED"]).nullish(),
  rating: zod
    .object({
      id: zod.string(),
      sessionId: zod.string(),
      trainerId: zod.string(),
      studentId: zod.string(),
      score: zod.number(),
      comment: zod.string().nullish(),
      createdAt: zod.date(),
    })
    .optional(),
  paidAt: zod.date().nullish(),
  createdAt: zod.date(),
});
export const GetGymSessionsResponse = zod.array(GetGymSessionsResponseItem);

/**
 * @summary Get session detail
 */
export const GetSessionParams = zod.object({
  id: zod.coerce.string(),
});

export const GetSessionResponse = zod.object({
  id: zod.string(),
  gymId: zod.string(),
  locationId: zod.string().nullish(),
  trainerId: zod.string(),
  studentId: zod.string(),
  trainer: zod
    .object({
      id: zod.string(),
      firstName: zod.string(),
      lastName: zod.string(),
      avatarUrl: zod.string().nullish(),
      email: zod.string(),
    })
    .optional(),
  student: zod
    .object({
      id: zod.string(),
      firstName: zod.string(),
      lastName: zod.string(),
      avatarUrl: zod.string().nullish(),
      email: zod.string(),
    })
    .optional(),
  location: zod
    .object({
      id: zod.string(),
      gymId: zod.string(),
      name: zod.string(),
      address: zod.string(),
      city: zod.string(),
      state: zod.string(),
      zipCode: zod.string().nullish(),
      phone: zod.string().nullish(),
      timezone: zod.string().nullish(),
      isActive: zod.boolean(),
      isPrimary: zod.boolean(),
      useSharedSchedule: zod.boolean(),
      availabilityMode: zod.enum(["CUSTOM"]),
      createdAt: zod.date(),
    })
    .optional(),
  proposedStart: zod.date(),
  proposedEnd: zod.date(),
  confirmedStart: zod.date().nullish(),
  confirmedEnd: zod.date().nullish(),
  durationMinutes: zod.number(),
  mode: zod.enum(["IN_PERSON", "VIDEO"]),
  dailyRoomUrl: zod.string().nullish(),
  rateSnapshot: zod.number(),
  splitSnapshot: zod.number(),
  platformFeeSnapshot: zod.number(),
  priceTotal: zod.number(),
  platformFee: zod.number(),
  netAfterPlatform: zod.number(),
  gymRevenue: zod.number(),
  trainerPayout: zod.number(),
  paymentType: zod.enum(["SINGLE", "PACKAGE", "MEMBERSHIP"]),
  status: zod.enum([
    "PENDING",
    "CONFIRMED",
    "AMENDMENT_PENDING",
    "REJECTED",
    "CANCELLED",
    "COMPLETED",
  ]),
  statusNote: zod.string().nullish(),
  amendedStart: zod.date().nullish(),
  amendedEnd: zod.date().nullish(),
  amendedBy: zod.string().nullish(),
  amendStatus: zod.enum(["PROPOSED", "ACCEPTED", "REJECTED"]).nullish(),
  rating: zod
    .object({
      id: zod.string(),
      sessionId: zod.string(),
      trainerId: zod.string(),
      studentId: zod.string(),
      score: zod.number(),
      comment: zod.string().nullish(),
      createdAt: zod.date(),
    })
    .optional(),
  paidAt: zod.date().nullish(),
  createdAt: zod.date(),
});

/**
 * @summary Confirm session (trainer)
 */
export const ConfirmSessionParams = zod.object({
  id: zod.coerce.string(),
});

export const ConfirmSessionResponse = zod.object({
  id: zod.string(),
  gymId: zod.string(),
  locationId: zod.string().nullish(),
  trainerId: zod.string(),
  studentId: zod.string(),
  trainer: zod
    .object({
      id: zod.string(),
      firstName: zod.string(),
      lastName: zod.string(),
      avatarUrl: zod.string().nullish(),
      email: zod.string(),
    })
    .optional(),
  student: zod
    .object({
      id: zod.string(),
      firstName: zod.string(),
      lastName: zod.string(),
      avatarUrl: zod.string().nullish(),
      email: zod.string(),
    })
    .optional(),
  location: zod
    .object({
      id: zod.string(),
      gymId: zod.string(),
      name: zod.string(),
      address: zod.string(),
      city: zod.string(),
      state: zod.string(),
      zipCode: zod.string().nullish(),
      phone: zod.string().nullish(),
      timezone: zod.string().nullish(),
      isActive: zod.boolean(),
      isPrimary: zod.boolean(),
      useSharedSchedule: zod.boolean(),
      availabilityMode: zod.enum(["CUSTOM"]),
      createdAt: zod.date(),
    })
    .optional(),
  proposedStart: zod.date(),
  proposedEnd: zod.date(),
  confirmedStart: zod.date().nullish(),
  confirmedEnd: zod.date().nullish(),
  durationMinutes: zod.number(),
  mode: zod.enum(["IN_PERSON", "VIDEO"]),
  dailyRoomUrl: zod.string().nullish(),
  rateSnapshot: zod.number(),
  splitSnapshot: zod.number(),
  platformFeeSnapshot: zod.number(),
  priceTotal: zod.number(),
  platformFee: zod.number(),
  netAfterPlatform: zod.number(),
  gymRevenue: zod.number(),
  trainerPayout: zod.number(),
  paymentType: zod.enum(["SINGLE", "PACKAGE", "MEMBERSHIP"]),
  status: zod.enum([
    "PENDING",
    "CONFIRMED",
    "AMENDMENT_PENDING",
    "REJECTED",
    "CANCELLED",
    "COMPLETED",
  ]),
  statusNote: zod.string().nullish(),
  amendedStart: zod.date().nullish(),
  amendedEnd: zod.date().nullish(),
  amendedBy: zod.string().nullish(),
  amendStatus: zod.enum(["PROPOSED", "ACCEPTED", "REJECTED"]).nullish(),
  rating: zod
    .object({
      id: zod.string(),
      sessionId: zod.string(),
      trainerId: zod.string(),
      studentId: zod.string(),
      score: zod.number(),
      comment: zod.string().nullish(),
      createdAt: zod.date(),
    })
    .optional(),
  paidAt: zod.date().nullish(),
  createdAt: zod.date(),
});

/**
 * @summary Reject session (trainer)
 */
export const RejectSessionParams = zod.object({
  id: zod.coerce.string(),
});

export const RejectSessionBody = zod.object({
  reason: zod.string().optional(),
});

export const RejectSessionResponse = zod.object({
  id: zod.string(),
  gymId: zod.string(),
  locationId: zod.string().nullish(),
  trainerId: zod.string(),
  studentId: zod.string(),
  trainer: zod
    .object({
      id: zod.string(),
      firstName: zod.string(),
      lastName: zod.string(),
      avatarUrl: zod.string().nullish(),
      email: zod.string(),
    })
    .optional(),
  student: zod
    .object({
      id: zod.string(),
      firstName: zod.string(),
      lastName: zod.string(),
      avatarUrl: zod.string().nullish(),
      email: zod.string(),
    })
    .optional(),
  location: zod
    .object({
      id: zod.string(),
      gymId: zod.string(),
      name: zod.string(),
      address: zod.string(),
      city: zod.string(),
      state: zod.string(),
      zipCode: zod.string().nullish(),
      phone: zod.string().nullish(),
      timezone: zod.string().nullish(),
      isActive: zod.boolean(),
      isPrimary: zod.boolean(),
      useSharedSchedule: zod.boolean(),
      availabilityMode: zod.enum(["CUSTOM"]),
      createdAt: zod.date(),
    })
    .optional(),
  proposedStart: zod.date(),
  proposedEnd: zod.date(),
  confirmedStart: zod.date().nullish(),
  confirmedEnd: zod.date().nullish(),
  durationMinutes: zod.number(),
  mode: zod.enum(["IN_PERSON", "VIDEO"]),
  dailyRoomUrl: zod.string().nullish(),
  rateSnapshot: zod.number(),
  splitSnapshot: zod.number(),
  platformFeeSnapshot: zod.number(),
  priceTotal: zod.number(),
  platformFee: zod.number(),
  netAfterPlatform: zod.number(),
  gymRevenue: zod.number(),
  trainerPayout: zod.number(),
  paymentType: zod.enum(["SINGLE", "PACKAGE", "MEMBERSHIP"]),
  status: zod.enum([
    "PENDING",
    "CONFIRMED",
    "AMENDMENT_PENDING",
    "REJECTED",
    "CANCELLED",
    "COMPLETED",
  ]),
  statusNote: zod.string().nullish(),
  amendedStart: zod.date().nullish(),
  amendedEnd: zod.date().nullish(),
  amendedBy: zod.string().nullish(),
  amendStatus: zod.enum(["PROPOSED", "ACCEPTED", "REJECTED"]).nullish(),
  rating: zod
    .object({
      id: zod.string(),
      sessionId: zod.string(),
      trainerId: zod.string(),
      studentId: zod.string(),
      score: zod.number(),
      comment: zod.string().nullish(),
      createdAt: zod.date(),
    })
    .optional(),
  paidAt: zod.date().nullish(),
  createdAt: zod.date(),
});

/**
 * @summary Propose time change
 */
export const AmendSessionParams = zod.object({
  id: zod.coerce.string(),
});

export const AmendSessionBody = zod.object({
  proposedStart: zod.date(),
  proposedEnd: zod.date(),
});

export const AmendSessionResponse = zod.object({
  id: zod.string(),
  gymId: zod.string(),
  locationId: zod.string().nullish(),
  trainerId: zod.string(),
  studentId: zod.string(),
  trainer: zod
    .object({
      id: zod.string(),
      firstName: zod.string(),
      lastName: zod.string(),
      avatarUrl: zod.string().nullish(),
      email: zod.string(),
    })
    .optional(),
  student: zod
    .object({
      id: zod.string(),
      firstName: zod.string(),
      lastName: zod.string(),
      avatarUrl: zod.string().nullish(),
      email: zod.string(),
    })
    .optional(),
  location: zod
    .object({
      id: zod.string(),
      gymId: zod.string(),
      name: zod.string(),
      address: zod.string(),
      city: zod.string(),
      state: zod.string(),
      zipCode: zod.string().nullish(),
      phone: zod.string().nullish(),
      timezone: zod.string().nullish(),
      isActive: zod.boolean(),
      isPrimary: zod.boolean(),
      useSharedSchedule: zod.boolean(),
      availabilityMode: zod.enum(["CUSTOM"]),
      createdAt: zod.date(),
    })
    .optional(),
  proposedStart: zod.date(),
  proposedEnd: zod.date(),
  confirmedStart: zod.date().nullish(),
  confirmedEnd: zod.date().nullish(),
  durationMinutes: zod.number(),
  mode: zod.enum(["IN_PERSON", "VIDEO"]),
  dailyRoomUrl: zod.string().nullish(),
  rateSnapshot: zod.number(),
  splitSnapshot: zod.number(),
  platformFeeSnapshot: zod.number(),
  priceTotal: zod.number(),
  platformFee: zod.number(),
  netAfterPlatform: zod.number(),
  gymRevenue: zod.number(),
  trainerPayout: zod.number(),
  paymentType: zod.enum(["SINGLE", "PACKAGE", "MEMBERSHIP"]),
  status: zod.enum([
    "PENDING",
    "CONFIRMED",
    "AMENDMENT_PENDING",
    "REJECTED",
    "CANCELLED",
    "COMPLETED",
  ]),
  statusNote: zod.string().nullish(),
  amendedStart: zod.date().nullish(),
  amendedEnd: zod.date().nullish(),
  amendedBy: zod.string().nullish(),
  amendStatus: zod.enum(["PROPOSED", "ACCEPTED", "REJECTED"]).nullish(),
  rating: zod
    .object({
      id: zod.string(),
      sessionId: zod.string(),
      trainerId: zod.string(),
      studentId: zod.string(),
      score: zod.number(),
      comment: zod.string().nullish(),
      createdAt: zod.date(),
    })
    .optional(),
  paidAt: zod.date().nullish(),
  createdAt: zod.date(),
});

/**
 * @summary Accept or reject amendment
 */
export const RespondToAmendmentParams = zod.object({
  id: zod.coerce.string(),
});

export const RespondToAmendmentBody = zod.object({
  accept: zod.boolean(),
});

export const RespondToAmendmentResponse = zod.object({
  id: zod.string(),
  gymId: zod.string(),
  locationId: zod.string().nullish(),
  trainerId: zod.string(),
  studentId: zod.string(),
  trainer: zod
    .object({
      id: zod.string(),
      firstName: zod.string(),
      lastName: zod.string(),
      avatarUrl: zod.string().nullish(),
      email: zod.string(),
    })
    .optional(),
  student: zod
    .object({
      id: zod.string(),
      firstName: zod.string(),
      lastName: zod.string(),
      avatarUrl: zod.string().nullish(),
      email: zod.string(),
    })
    .optional(),
  location: zod
    .object({
      id: zod.string(),
      gymId: zod.string(),
      name: zod.string(),
      address: zod.string(),
      city: zod.string(),
      state: zod.string(),
      zipCode: zod.string().nullish(),
      phone: zod.string().nullish(),
      timezone: zod.string().nullish(),
      isActive: zod.boolean(),
      isPrimary: zod.boolean(),
      useSharedSchedule: zod.boolean(),
      availabilityMode: zod.enum(["CUSTOM"]),
      createdAt: zod.date(),
    })
    .optional(),
  proposedStart: zod.date(),
  proposedEnd: zod.date(),
  confirmedStart: zod.date().nullish(),
  confirmedEnd: zod.date().nullish(),
  durationMinutes: zod.number(),
  mode: zod.enum(["IN_PERSON", "VIDEO"]),
  dailyRoomUrl: zod.string().nullish(),
  rateSnapshot: zod.number(),
  splitSnapshot: zod.number(),
  platformFeeSnapshot: zod.number(),
  priceTotal: zod.number(),
  platformFee: zod.number(),
  netAfterPlatform: zod.number(),
  gymRevenue: zod.number(),
  trainerPayout: zod.number(),
  paymentType: zod.enum(["SINGLE", "PACKAGE", "MEMBERSHIP"]),
  status: zod.enum([
    "PENDING",
    "CONFIRMED",
    "AMENDMENT_PENDING",
    "REJECTED",
    "CANCELLED",
    "COMPLETED",
  ]),
  statusNote: zod.string().nullish(),
  amendedStart: zod.date().nullish(),
  amendedEnd: zod.date().nullish(),
  amendedBy: zod.string().nullish(),
  amendStatus: zod.enum(["PROPOSED", "ACCEPTED", "REJECTED"]).nullish(),
  rating: zod
    .object({
      id: zod.string(),
      sessionId: zod.string(),
      trainerId: zod.string(),
      studentId: zod.string(),
      score: zod.number(),
      comment: zod.string().nullish(),
      createdAt: zod.date(),
    })
    .optional(),
  paidAt: zod.date().nullish(),
  createdAt: zod.date(),
});

/**
 * @summary Cancel session
 */
export const CancelSessionParams = zod.object({
  id: zod.coerce.string(),
});

export const CancelSessionResponse = zod.object({
  id: zod.string(),
  gymId: zod.string(),
  locationId: zod.string().nullish(),
  trainerId: zod.string(),
  studentId: zod.string(),
  trainer: zod
    .object({
      id: zod.string(),
      firstName: zod.string(),
      lastName: zod.string(),
      avatarUrl: zod.string().nullish(),
      email: zod.string(),
    })
    .optional(),
  student: zod
    .object({
      id: zod.string(),
      firstName: zod.string(),
      lastName: zod.string(),
      avatarUrl: zod.string().nullish(),
      email: zod.string(),
    })
    .optional(),
  location: zod
    .object({
      id: zod.string(),
      gymId: zod.string(),
      name: zod.string(),
      address: zod.string(),
      city: zod.string(),
      state: zod.string(),
      zipCode: zod.string().nullish(),
      phone: zod.string().nullish(),
      timezone: zod.string().nullish(),
      isActive: zod.boolean(),
      isPrimary: zod.boolean(),
      useSharedSchedule: zod.boolean(),
      availabilityMode: zod.enum(["CUSTOM"]),
      createdAt: zod.date(),
    })
    .optional(),
  proposedStart: zod.date(),
  proposedEnd: zod.date(),
  confirmedStart: zod.date().nullish(),
  confirmedEnd: zod.date().nullish(),
  durationMinutes: zod.number(),
  mode: zod.enum(["IN_PERSON", "VIDEO"]),
  dailyRoomUrl: zod.string().nullish(),
  rateSnapshot: zod.number(),
  splitSnapshot: zod.number(),
  platformFeeSnapshot: zod.number(),
  priceTotal: zod.number(),
  platformFee: zod.number(),
  netAfterPlatform: zod.number(),
  gymRevenue: zod.number(),
  trainerPayout: zod.number(),
  paymentType: zod.enum(["SINGLE", "PACKAGE", "MEMBERSHIP"]),
  status: zod.enum([
    "PENDING",
    "CONFIRMED",
    "AMENDMENT_PENDING",
    "REJECTED",
    "CANCELLED",
    "COMPLETED",
  ]),
  statusNote: zod.string().nullish(),
  amendedStart: zod.date().nullish(),
  amendedEnd: zod.date().nullish(),
  amendedBy: zod.string().nullish(),
  amendStatus: zod.enum(["PROPOSED", "ACCEPTED", "REJECTED"]).nullish(),
  rating: zod
    .object({
      id: zod.string(),
      sessionId: zod.string(),
      trainerId: zod.string(),
      studentId: zod.string(),
      score: zod.number(),
      comment: zod.string().nullish(),
      createdAt: zod.date(),
    })
    .optional(),
  paidAt: zod.date().nullish(),
  createdAt: zod.date(),
});

/**
 * @summary Mark session complete
 */
export const CompleteSessionParams = zod.object({
  id: zod.coerce.string(),
});

export const CompleteSessionResponse = zod.object({
  id: zod.string(),
  gymId: zod.string(),
  locationId: zod.string().nullish(),
  trainerId: zod.string(),
  studentId: zod.string(),
  trainer: zod
    .object({
      id: zod.string(),
      firstName: zod.string(),
      lastName: zod.string(),
      avatarUrl: zod.string().nullish(),
      email: zod.string(),
    })
    .optional(),
  student: zod
    .object({
      id: zod.string(),
      firstName: zod.string(),
      lastName: zod.string(),
      avatarUrl: zod.string().nullish(),
      email: zod.string(),
    })
    .optional(),
  location: zod
    .object({
      id: zod.string(),
      gymId: zod.string(),
      name: zod.string(),
      address: zod.string(),
      city: zod.string(),
      state: zod.string(),
      zipCode: zod.string().nullish(),
      phone: zod.string().nullish(),
      timezone: zod.string().nullish(),
      isActive: zod.boolean(),
      isPrimary: zod.boolean(),
      useSharedSchedule: zod.boolean(),
      availabilityMode: zod.enum(["CUSTOM"]),
      createdAt: zod.date(),
    })
    .optional(),
  proposedStart: zod.date(),
  proposedEnd: zod.date(),
  confirmedStart: zod.date().nullish(),
  confirmedEnd: zod.date().nullish(),
  durationMinutes: zod.number(),
  mode: zod.enum(["IN_PERSON", "VIDEO"]),
  dailyRoomUrl: zod.string().nullish(),
  rateSnapshot: zod.number(),
  splitSnapshot: zod.number(),
  platformFeeSnapshot: zod.number(),
  priceTotal: zod.number(),
  platformFee: zod.number(),
  netAfterPlatform: zod.number(),
  gymRevenue: zod.number(),
  trainerPayout: zod.number(),
  paymentType: zod.enum(["SINGLE", "PACKAGE", "MEMBERSHIP"]),
  status: zod.enum([
    "PENDING",
    "CONFIRMED",
    "AMENDMENT_PENDING",
    "REJECTED",
    "CANCELLED",
    "COMPLETED",
  ]),
  statusNote: zod.string().nullish(),
  amendedStart: zod.date().nullish(),
  amendedEnd: zod.date().nullish(),
  amendedBy: zod.string().nullish(),
  amendStatus: zod.enum(["PROPOSED", "ACCEPTED", "REJECTED"]).nullish(),
  rating: zod
    .object({
      id: zod.string(),
      sessionId: zod.string(),
      trainerId: zod.string(),
      studentId: zod.string(),
      score: zod.number(),
      comment: zod.string().nullish(),
      createdAt: zod.date(),
    })
    .optional(),
  paidAt: zod.date().nullish(),
  createdAt: zod.date(),
});

/**
 * @summary List group classes
 */
export const ListClassesParams = zod.object({
  gymId: zod.coerce.string(),
});

export const ListClassesQueryParams = zod.object({
  locationId: zod.coerce.string().optional(),
  discipline: zod.coerce.string().optional(),
  level: zod.coerce.string().optional(),
  from: zod.date().optional(),
  to: zod.date().optional(),
});

export const ListClassesResponseItem = zod.object({
  id: zod.string(),
  gymId: zod.string(),
  locationId: zod.string().nullish(),
  trainerId: zod.string(),
  trainer: zod
    .object({
      id: zod.string(),
      firstName: zod.string(),
      lastName: zod.string(),
      avatarUrl: zod.string().nullish(),
      email: zod.string(),
    })
    .optional(),
  location: zod
    .object({
      id: zod.string(),
      gymId: zod.string(),
      name: zod.string(),
      address: zod.string(),
      city: zod.string(),
      state: zod.string(),
      zipCode: zod.string().nullish(),
      phone: zod.string().nullish(),
      timezone: zod.string().nullish(),
      isActive: zod.boolean(),
      isPrimary: zod.boolean(),
      useSharedSchedule: zod.boolean(),
      availabilityMode: zod.enum(["CUSTOM"]),
      createdAt: zod.date(),
    })
    .optional(),
  title: zod.string(),
  description: zod.string().nullish(),
  discipline: zod.string().nullish(),
  level: zod.string().nullish(),
  imageUrl: zod.string().nullish(),
  startTime: zod.date(),
  endTime: zod.date(),
  durationMinutes: zod.number(),
  isRecurring: zod.boolean(),
  capacityLimit: zod.number(),
  enrolledCount: zod.number(),
  waitlistCount: zod.number(),
  price: zod.number(),
  isFree: zod.boolean(),
  mode: zod.enum(["IN_PERSON", "VIDEO"]),
  status: zod.enum(["SCHEDULED", "CANCELLED", "COMPLETED"]),
  createdAt: zod.date(),
});
export const ListClassesResponse = zod.array(ListClassesResponseItem);

/**
 * @summary Create group class
 */
export const CreateClassBody = zod.object({
  gymId: zod.string(),
  locationId: zod.string().optional(),
  trainerId: zod.string(),
  title: zod.string(),
  description: zod.string().optional(),
  discipline: zod.string().optional(),
  level: zod.string().optional(),
  startTime: zod.date(),
  endTime: zod.date(),
  durationMinutes: zod.number(),
  isRecurring: zod.boolean().optional(),
  recurrenceRule: zod.string().optional(),
  capacityLimit: zod.number(),
  price: zod.number(),
  isFree: zod.boolean().optional(),
  mode: zod.enum(["IN_PERSON", "VIDEO"]).optional(),
});

/**
 * @summary Get class detail
 */
export const GetClassParams = zod.object({
  id: zod.coerce.string(),
});

export const GetClassResponse = zod.object({
  id: zod.string(),
  gymId: zod.string(),
  locationId: zod.string().nullish(),
  trainerId: zod.string(),
  trainer: zod
    .object({
      id: zod.string(),
      firstName: zod.string(),
      lastName: zod.string(),
      avatarUrl: zod.string().nullish(),
      email: zod.string(),
    })
    .optional(),
  location: zod
    .object({
      id: zod.string(),
      gymId: zod.string(),
      name: zod.string(),
      address: zod.string(),
      city: zod.string(),
      state: zod.string(),
      zipCode: zod.string().nullish(),
      phone: zod.string().nullish(),
      timezone: zod.string().nullish(),
      isActive: zod.boolean(),
      isPrimary: zod.boolean(),
      useSharedSchedule: zod.boolean(),
      availabilityMode: zod.enum(["CUSTOM"]),
      createdAt: zod.date(),
    })
    .optional(),
  title: zod.string(),
  description: zod.string().nullish(),
  discipline: zod.string().nullish(),
  level: zod.string().nullish(),
  imageUrl: zod.string().nullish(),
  startTime: zod.date(),
  endTime: zod.date(),
  durationMinutes: zod.number(),
  isRecurring: zod.boolean(),
  capacityLimit: zod.number(),
  enrolledCount: zod.number(),
  waitlistCount: zod.number(),
  price: zod.number(),
  isFree: zod.boolean(),
  mode: zod.enum(["IN_PERSON", "VIDEO"]),
  status: zod.enum(["SCHEDULED", "CANCELLED", "COMPLETED"]),
  createdAt: zod.date(),
});

/**
 * @summary Update class
 */
export const UpdateClassParams = zod.object({
  id: zod.coerce.string(),
});

export const UpdateClassBody = zod.object({
  title: zod.string().optional(),
  description: zod.string().optional(),
  discipline: zod.string().optional(),
  level: zod.string().optional(),
  capacityLimit: zod.number().optional(),
  price: zod.number().optional(),
  isFree: zod.boolean().optional(),
});

export const UpdateClassResponse = zod.object({
  id: zod.string(),
  gymId: zod.string(),
  locationId: zod.string().nullish(),
  trainerId: zod.string(),
  trainer: zod
    .object({
      id: zod.string(),
      firstName: zod.string(),
      lastName: zod.string(),
      avatarUrl: zod.string().nullish(),
      email: zod.string(),
    })
    .optional(),
  location: zod
    .object({
      id: zod.string(),
      gymId: zod.string(),
      name: zod.string(),
      address: zod.string(),
      city: zod.string(),
      state: zod.string(),
      zipCode: zod.string().nullish(),
      phone: zod.string().nullish(),
      timezone: zod.string().nullish(),
      isActive: zod.boolean(),
      isPrimary: zod.boolean(),
      useSharedSchedule: zod.boolean(),
      availabilityMode: zod.enum(["CUSTOM"]),
      createdAt: zod.date(),
    })
    .optional(),
  title: zod.string(),
  description: zod.string().nullish(),
  discipline: zod.string().nullish(),
  level: zod.string().nullish(),
  imageUrl: zod.string().nullish(),
  startTime: zod.date(),
  endTime: zod.date(),
  durationMinutes: zod.number(),
  isRecurring: zod.boolean(),
  capacityLimit: zod.number(),
  enrolledCount: zod.number(),
  waitlistCount: zod.number(),
  price: zod.number(),
  isFree: zod.boolean(),
  mode: zod.enum(["IN_PERSON", "VIDEO"]),
  status: zod.enum(["SCHEDULED", "CANCELLED", "COMPLETED"]),
  createdAt: zod.date(),
});

/**
 * @summary Cancel class
 */
export const CancelClassParams = zod.object({
  id: zod.coerce.string(),
});

export const CancelClassResponse = zod.object({
  message: zod.string(),
});

/**
 * @summary Enroll in class
 */
export const EnrollInClassParams = zod.object({
  id: zod.coerce.string(),
});

export const EnrollInClassBody = zod.object({
  paymentType: zod.enum(["SINGLE", "PACKAGE", "MEMBERSHIP"]),
  packagePurchaseId: zod.string().optional(),
  membershipId: zod.string().optional(),
});

export const EnrollInClassResponse = zod.object({
  id: zod.string(),
  classId: zod.string(),
  studentId: zod.string(),
  student: zod
    .object({
      id: zod.string(),
      firstName: zod.string(),
      lastName: zod.string(),
      avatarUrl: zod.string().nullish(),
      email: zod.string(),
    })
    .optional(),
  status: zod.enum([
    "ENROLLED",
    "WAITLISTED",
    "CANCELLED",
    "ATTENDED",
    "NO_SHOW",
  ]),
  paymentType: zod.enum(["SINGLE", "PACKAGE", "MEMBERSHIP"]),
  pricePaid: zod.number(),
  createdAt: zod.date(),
});

/**
 * @summary Cancel enrollment
 */
export const CancelEnrollmentParams = zod.object({
  id: zod.coerce.string(),
});

export const CancelEnrollmentResponse = zod.object({
  message: zod.string(),
});

/**
 * @summary Join waitlist
 */
export const JoinWaitlistParams = zod.object({
  id: zod.coerce.string(),
});

export const JoinWaitlistResponse = zod.object({
  id: zod.string(),
  classId: zod.string(),
  studentId: zod.string(),
  position: zod.number(),
  isActive: zod.boolean(),
  createdAt: zod.date(),
});

/**
 * @summary Leave waitlist
 */
export const LeaveWaitlistParams = zod.object({
  id: zod.coerce.string(),
});

export const LeaveWaitlistResponse = zod.object({
  message: zod.string(),
});

/**
 * @summary Get enrolled students
 */
export const GetClassRosterParams = zod.object({
  id: zod.coerce.string(),
});

export const GetClassRosterResponseItem = zod.object({
  id: zod.string(),
  classId: zod.string(),
  studentId: zod.string(),
  student: zod
    .object({
      id: zod.string(),
      firstName: zod.string(),
      lastName: zod.string(),
      avatarUrl: zod.string().nullish(),
      email: zod.string(),
    })
    .optional(),
  status: zod.enum([
    "ENROLLED",
    "WAITLISTED",
    "CANCELLED",
    "ATTENDED",
    "NO_SHOW",
  ]),
  paymentType: zod.enum(["SINGLE", "PACKAGE", "MEMBERSHIP"]),
  pricePaid: zod.number(),
  createdAt: zod.date(),
});
export const GetClassRosterResponse = zod.array(GetClassRosterResponseItem);

/**
 * @summary Mark class completed
 */
export const CompleteClassParams = zod.object({
  id: zod.coerce.string(),
});

export const CompleteClassResponse = zod.object({
  id: zod.string(),
  gymId: zod.string(),
  locationId: zod.string().nullish(),
  trainerId: zod.string(),
  trainer: zod
    .object({
      id: zod.string(),
      firstName: zod.string(),
      lastName: zod.string(),
      avatarUrl: zod.string().nullish(),
      email: zod.string(),
    })
    .optional(),
  location: zod
    .object({
      id: zod.string(),
      gymId: zod.string(),
      name: zod.string(),
      address: zod.string(),
      city: zod.string(),
      state: zod.string(),
      zipCode: zod.string().nullish(),
      phone: zod.string().nullish(),
      timezone: zod.string().nullish(),
      isActive: zod.boolean(),
      isPrimary: zod.boolean(),
      useSharedSchedule: zod.boolean(),
      availabilityMode: zod.enum(["CUSTOM"]),
      createdAt: zod.date(),
    })
    .optional(),
  title: zod.string(),
  description: zod.string().nullish(),
  discipline: zod.string().nullish(),
  level: zod.string().nullish(),
  imageUrl: zod.string().nullish(),
  startTime: zod.date(),
  endTime: zod.date(),
  durationMinutes: zod.number(),
  isRecurring: zod.boolean(),
  capacityLimit: zod.number(),
  enrolledCount: zod.number(),
  waitlistCount: zod.number(),
  price: zod.number(),
  isFree: zod.boolean(),
  mode: zod.enum(["IN_PERSON", "VIDEO"]),
  status: zod.enum(["SCHEDULED", "CANCELLED", "COMPLETED"]),
  createdAt: zod.date(),
});

/**
 * @summary List active packages for gym
 */
export const ListPackagesParams = zod.object({
  gymId: zod.coerce.string(),
});

export const ListPackagesResponseItem = zod.object({
  id: zod.string(),
  gymId: zod.string(),
  name: zod.string(),
  description: zod.string().nullish(),
  sessionCount: zod.number(),
  appliesToPrivates: zod.boolean(),
  appliesToGroupClasses: zod.boolean(),
  priceTotal: zod.number(),
  pricePerSession: zod.number(),
  savingsPct: zod.number().nullish(),
  isActive: zod.boolean(),
  expiryDays: zod.number().nullish(),
  createdAt: zod.date(),
});
export const ListPackagesResponse = zod.array(ListPackagesResponseItem);

/**
 * @summary Create session package
 */
export const CreatePackageBody = zod.object({
  gymId: zod.string(),
  name: zod.string(),
  description: zod.string().optional(),
  sessionCount: zod.number(),
  appliesToPrivates: zod.boolean().optional(),
  appliesToGroupClasses: zod.boolean().optional(),
  priceTotal: zod.number(),
  pricePerSession: zod.number(),
  savingsPct: zod.number().optional(),
  expiryDays: zod.number().optional(),
});

/**
 * @summary Update package
 */
export const UpdatePackageParams = zod.object({
  id: zod.coerce.string(),
});

export const UpdatePackageBody = zod.object({
  name: zod.string().optional(),
  description: zod.string().optional(),
  priceTotal: zod.number().optional(),
  pricePerSession: zod.number().optional(),
  savingsPct: zod.number().optional(),
  isActive: zod.boolean().optional(),
});

export const UpdatePackageResponse = zod.object({
  id: zod.string(),
  gymId: zod.string(),
  name: zod.string(),
  description: zod.string().nullish(),
  sessionCount: zod.number(),
  appliesToPrivates: zod.boolean(),
  appliesToGroupClasses: zod.boolean(),
  priceTotal: zod.number(),
  pricePerSession: zod.number(),
  savingsPct: zod.number().nullish(),
  isActive: zod.boolean(),
  expiryDays: zod.number().nullish(),
  createdAt: zod.date(),
});

/**
 * @summary Soft delete package
 */
export const DeletePackageParams = zod.object({
  id: zod.coerce.string(),
});

export const DeletePackageResponse = zod.object({
  message: zod.string(),
});

/**
 * @summary Buy package (student)
 */
export const PurchasePackageBody = zod.object({
  packageId: zod.string(),
  gymId: zod.string(),
});

export const PurchasePackageResponse = zod.object({
  url: zod.string(),
});

/**
 * @summary Get student credits
 */
export const GetMyCreditsResponseItem = zod.object({
  id: zod.string(),
  packageId: zod.string(),
  studentId: zod.string(),
  packageName: zod.string(),
  creditsTotal: zod.number(),
  creditsUsed: zod.number(),
  creditsRemaining: zod.number(),
  pricePaid: zod.number(),
  expiresAt: zod.date().nullish(),
  paidAt: zod.date().nullish(),
  createdAt: zod.date(),
  autoRenew: zod.boolean(),
  autoRenewFailureCount: zod.number(),
  autoRenewFailedAt: zod.date().nullish(),
});
export const GetMyCreditsResponse = zod.array(GetMyCreditsResponseItem);

/**
 * @summary Toggle auto-renewal for a package purchase
 */
export const UpdateAutoRenewParams = zod.object({
  id: zod.coerce.string(),
});

export const UpdateAutoRenewBody = zod.object({
  autoRenew: zod.boolean(),
  stripePaymentMethodId: zod.string().optional(),
});

export const UpdateAutoRenewResponse = zod.object({
  id: zod.string(),
  packageId: zod.string(),
  studentId: zod.string(),
  packageName: zod.string(),
  creditsTotal: zod.number(),
  creditsUsed: zod.number(),
  creditsRemaining: zod.number(),
  pricePaid: zod.number(),
  expiresAt: zod.date().nullish(),
  paidAt: zod.date().nullish(),
  createdAt: zod.date(),
  autoRenew: zod.boolean(),
  autoRenewFailureCount: zod.number(),
  autoRenewFailedAt: zod.date().nullish(),
});

/**
 * @summary All package purchases for gym (admin)
 */
export const GetGymPackagePurchasesParams = zod.object({
  gymId: zod.coerce.string(),
});

export const GetGymPackagePurchasesResponseItem = zod.object({
  id: zod.string(),
  packageId: zod.string(),
  studentId: zod.string(),
  packageName: zod.string(),
  creditsTotal: zod.number(),
  creditsUsed: zod.number(),
  creditsRemaining: zod.number(),
  pricePaid: zod.number(),
  expiresAt: zod.date().nullish(),
  paidAt: zod.date().nullish(),
  createdAt: zod.date(),
  autoRenew: zod.boolean(),
  autoRenewFailureCount: zod.number(),
  autoRenewFailedAt: zod.date().nullish(),
});
export const GetGymPackagePurchasesResponse = zod.array(
  GetGymPackagePurchasesResponseItem,
);

/**
 * @summary List membership plans for gym
 */
export const ListMembershipPlansParams = zod.object({
  gymId: zod.coerce.string(),
});

export const ListMembershipPlansResponseItem = zod.object({
  id: zod.string(),
  gymId: zod.string(),
  name: zod.string(),
  description: zod.string().nullish(),
  priceMonthly: zod.number(),
  privateCredits: zod.number(),
  discountPct: zod.number(),
  isActive: zod.boolean(),
  createdAt: zod.date(),
});
export const ListMembershipPlansResponse = zod.array(
  ListMembershipPlansResponseItem,
);

/**
 * @summary List all membership plans for gym (admin)
 */
export const ListAllMembershipPlansParams = zod.object({
  gymId: zod.coerce.string(),
});

export const ListAllMembershipPlansResponseItem = zod.object({
  id: zod.string(),
  gymId: zod.string(),
  name: zod.string(),
  description: zod.string().nullish(),
  priceMonthly: zod.number(),
  privateCredits: zod.number(),
  discountPct: zod.number(),
  isActive: zod.boolean(),
  createdAt: zod.date(),
});
export const ListAllMembershipPlansResponse = zod.array(
  ListAllMembershipPlansResponseItem,
);

/**
 * @summary Create membership plan
 */
export const CreateMembershipPlanBody = zod.object({
  gymId: zod.string(),
  name: zod.string(),
  description: zod.string().optional(),
  priceMonthly: zod.number(),
  privateCredits: zod.number().optional(),
  discountPct: zod.number().optional(),
});

/**
 * @summary Update membership plan
 */
export const UpdateMembershipPlanParams = zod.object({
  id: zod.coerce.string(),
});

export const UpdateMembershipPlanBody = zod.object({
  name: zod.string().optional(),
  description: zod.string().optional(),
  priceMonthly: zod.number().optional(),
  privateCredits: zod.number().optional(),
  discountPct: zod.number().optional(),
  isActive: zod.boolean().optional(),
});

export const UpdateMembershipPlanResponse = zod.object({
  id: zod.string(),
  gymId: zod.string(),
  name: zod.string(),
  description: zod.string().nullish(),
  priceMonthly: zod.number(),
  privateCredits: zod.number(),
  discountPct: zod.number(),
  isActive: zod.boolean(),
  createdAt: zod.date(),
});

/**
 * @summary Deactivate plan
 */
export const DeleteMembershipPlanParams = zod.object({
  id: zod.coerce.string(),
});

export const DeleteMembershipPlanResponse = zod.object({
  message: zod.string(),
});

/**
 * @summary Subscribe to membership
 */
export const MembershipCheckoutBody = zod.object({
  planId: zod.string(),
});

export const MembershipCheckoutResponse = zod.object({
  url: zod.string(),
});

/**
 * @summary Get student active membership
 */
export const GetMyMembershipResponse = zod.object({
  id: zod.string(),
  planId: zod.string(),
  studentId: zod.string(),
  planName: zod.string(),
  status: zod.enum(["ACTIVE", "PAST_DUE", "CANCELLED", "PAUSED"]),
  privateCreditsRemaining: zod.number(),
  discountPct: zod.number(),
  creditsResetAt: zod.date(),
  currentPeriodEnd: zod.date().nullish(),
  cancelAtPeriodEnd: zod.boolean(),
  cancelledAt: zod.date().nullish(),
  effectiveEndDate: zod.date().nullish(),
  createdAt: zod.date(),
});

/**
 * @summary Cancel membership at period end
 */
export const CancelMembershipParams = zod.object({
  id: zod.coerce.string(),
});

export const CancelMembershipResponse = zod.object({
  id: zod.string(),
  planId: zod.string(),
  studentId: zod.string(),
  planName: zod.string(),
  status: zod.enum(["ACTIVE", "PAST_DUE", "CANCELLED", "PAUSED"]),
  privateCreditsRemaining: zod.number(),
  discountPct: zod.number(),
  creditsResetAt: zod.date(),
  currentPeriodEnd: zod.date().nullish(),
  cancelAtPeriodEnd: zod.boolean(),
  cancelledAt: zod.date().nullish(),
  effectiveEndDate: zod.date().nullish(),
  createdAt: zod.date(),
});

/**
 * @summary All active memberships at gym (admin)
 */
export const GetGymMembershipsParams = zod.object({
  gymId: zod.coerce.string(),
});

export const GetGymMembershipsResponseItem = zod.object({
  id: zod.string(),
  planId: zod.string(),
  studentId: zod.string(),
  planName: zod.string(),
  status: zod.enum(["ACTIVE", "PAST_DUE", "CANCELLED", "PAUSED"]),
  privateCreditsRemaining: zod.number(),
  discountPct: zod.number(),
  creditsResetAt: zod.date(),
  currentPeriodEnd: zod.date().nullish(),
  cancelAtPeriodEnd: zod.boolean(),
  cancelledAt: zod.date().nullish(),
  effectiveEndDate: zod.date().nullish(),
  createdAt: zod.date(),
});
export const GetGymMembershipsResponse = zod.array(
  GetGymMembershipsResponseItem,
);

/**
 * @summary Single session checkout
 */
export const CheckoutSessionBody = zod.object({
  sessionId: zod.string(),
});

export const CheckoutSessionResponse = zod.object({
  url: zod.string(),
});

/**
 * @summary Class drop-in checkout
 */
export const CheckoutClassBody = zod.object({
  classId: zod.string(),
});

export const CheckoutClassResponse = zod.object({
  url: zod.string(),
});

/**
 * @summary Stripe webhook handler
 */
export const StripeWebhookResponse = zod.object({
  message: zod.string(),
});

/**
 * @summary Premium subscription checkout
 */
export const BillingCheckoutResponse = zod.object({
  url: zod.string(),
});

/**
 * @summary Stripe Billing Portal
 */
export const BillingPortalResponse = zod.object({
  url: zod.string(),
});

/**
 * @summary Get billing status
 */
export const GetBillingStatusParams = zod.object({
  gymId: zod.coerce.string(),
});

export const GetBillingStatusResponse = zod.object({
  platformPlan: zod.enum(["FREE", "PREMIUM"]),
  platformFeePerSession: zod.number(),
  stripeCustomerId: zod.string().nullish(),
  subscriptionStatus: zod.string().nullish(),
  subscriptionCurrentPeriodEnd: zod.date().nullish(),
  isTrialing: zod.boolean().optional(),
  trialEndsAt: zod.date().nullish(),
  stripeConnectAccountId: zod.string().nullish(),
  stripeConnectOnboarded: zod.boolean().optional(),
  stripeConnectPayoutsEnabled: zod.boolean().optional(),
});

/**
 * @summary Create or refresh gym Stripe Connect onboarding link
 */
export const GymStripeConnectRefreshParams = zod.object({
  gymId: zod.coerce.string(),
});

export const GymStripeConnectRefreshResponse = zod.object({
  url: zod.string(),
});

/**
 * @summary Verify gym Stripe Connect onboarding completion
 */
export const GymStripeConnectCompleteParams = zod.object({
  gymId: zod.coerce.string(),
});

export const GymStripeConnectCompleteResponse = zod.object({
  onboarded: zod.boolean(),
  payoutsEnabled: zod.boolean(),
});

/**
 * @summary All payout batches for gym
 */
export const GetGymPayoutsParams = zod.object({
  gymId: zod.coerce.string(),
});

export const GetGymPayoutsResponseItem = zod.object({
  id: zod.string(),
  gymId: zod.string(),
  batchType: zod.enum(["GYM", "TRAINER"]),
  recipientId: zod.string(),
  recipientName: zod.string(),
  totalAmount: zod.number(),
  sessionCount: zod.number(),
  status: zod.enum(["PENDING", "PROCESSING", "COMPLETED", "FAILED"]),
  processedAt: zod.date().nullish(),
  createdAt: zod.date(),
});
export const GetGymPayoutsResponse = zod.array(GetGymPayoutsResponseItem);

/**
 * @summary Trainer payout history
 */
export const GetMyPayoutsResponseItem = zod.object({
  id: zod.string(),
  gymId: zod.string(),
  batchType: zod.enum(["GYM", "TRAINER"]),
  recipientId: zod.string(),
  recipientName: zod.string(),
  totalAmount: zod.number(),
  sessionCount: zod.number(),
  status: zod.enum(["PENDING", "PROCESSING", "COMPLETED", "FAILED"]),
  processedAt: zod.date().nullish(),
  createdAt: zod.date(),
});
export const GetMyPayoutsResponse = zod.array(GetMyPayoutsResponseItem);

/**
 * @summary Rate a trainer after session
 */
export const CreateRatingBody = zod.object({
  sessionId: zod.string(),
  score: zod.number(),
  comment: zod.string().optional(),
});

/**
 * @summary Get user notifications
 */
export const GetNotificationsResponseItem = zod.object({
  id: zod.string(),
  userId: zod.string(),
  sessionId: zod.string().nullish(),
  type: zod.string(),
  message: zod.string(),
  isRead: zod.boolean(),
  createdAt: zod.date(),
});
export const GetNotificationsResponse = zod.array(GetNotificationsResponseItem);

/**
 * @summary Mark notification as read
 */
export const MarkNotificationReadParams = zod.object({
  id: zod.coerce.string(),
});

export const MarkNotificationReadResponse = zod.object({
  message: zod.string(),
});

/**
 * @summary Mark all notifications as read
 */
export const MarkAllNotificationsReadResponse = zod.object({
  message: zod.string(),
});

/**
 * @summary Update notification preferences
 */
export const UpdateNotificationPreferencesBody = zod.object({
  smsEnabled: zod.boolean().optional(),
  emailEnabled: zod.boolean().optional(),
});

export const UpdateNotificationPreferencesResponse = zod.object({
  message: zod.string(),
});

/**
 * @summary Admin KPIs
 */
export const GetAdminDashboardResponse = zod.object({
  totalSessions: zod.number(),
  completedSessions: zod.number(),
  pendingSessions: zod.number(),
  totalRevenue: zod.number(),
  trainerCount: zod.number(),
  studentCount: zod.number(),
  activeClasses: zod.number(),
  activeMemberships: zod.number(),
  recentSessions: zod.array(
    zod.object({
      id: zod.string(),
      gymId: zod.string(),
      locationId: zod.string().nullish(),
      trainerId: zod.string(),
      studentId: zod.string(),
      trainer: zod
        .object({
          id: zod.string(),
          firstName: zod.string(),
          lastName: zod.string(),
          avatarUrl: zod.string().nullish(),
          email: zod.string(),
        })
        .optional(),
      student: zod
        .object({
          id: zod.string(),
          firstName: zod.string(),
          lastName: zod.string(),
          avatarUrl: zod.string().nullish(),
          email: zod.string(),
        })
        .optional(),
      location: zod
        .object({
          id: zod.string(),
          gymId: zod.string(),
          name: zod.string(),
          address: zod.string(),
          city: zod.string(),
          state: zod.string(),
          zipCode: zod.string().nullish(),
          phone: zod.string().nullish(),
          timezone: zod.string().nullish(),
          isActive: zod.boolean(),
          isPrimary: zod.boolean(),
          useSharedSchedule: zod.boolean(),
          availabilityMode: zod.enum(["CUSTOM"]),
          createdAt: zod.date(),
        })
        .optional(),
      proposedStart: zod.date(),
      proposedEnd: zod.date(),
      confirmedStart: zod.date().nullish(),
      confirmedEnd: zod.date().nullish(),
      durationMinutes: zod.number(),
      mode: zod.enum(["IN_PERSON", "VIDEO"]),
      dailyRoomUrl: zod.string().nullish(),
      rateSnapshot: zod.number(),
      splitSnapshot: zod.number(),
      platformFeeSnapshot: zod.number(),
      priceTotal: zod.number(),
      platformFee: zod.number(),
      netAfterPlatform: zod.number(),
      gymRevenue: zod.number(),
      trainerPayout: zod.number(),
      paymentType: zod.enum(["SINGLE", "PACKAGE", "MEMBERSHIP"]),
      status: zod.enum([
        "PENDING",
        "CONFIRMED",
        "AMENDMENT_PENDING",
        "REJECTED",
        "CANCELLED",
        "COMPLETED",
      ]),
      statusNote: zod.string().nullish(),
      amendedStart: zod.date().nullish(),
      amendedEnd: zod.date().nullish(),
      amendedBy: zod.string().nullish(),
      amendStatus: zod.enum(["PROPOSED", "ACCEPTED", "REJECTED"]).nullish(),
      rating: zod
        .object({
          id: zod.string(),
          sessionId: zod.string(),
          trainerId: zod.string(),
          studentId: zod.string(),
          score: zod.number(),
          comment: zod.string().nullish(),
          createdAt: zod.date(),
        })
        .optional(),
      paidAt: zod.date().nullish(),
      createdAt: zod.date(),
    }),
  ),
  upcomingClasses: zod.array(
    zod.object({
      id: zod.string(),
      gymId: zod.string(),
      locationId: zod.string().nullish(),
      trainerId: zod.string(),
      trainer: zod
        .object({
          id: zod.string(),
          firstName: zod.string(),
          lastName: zod.string(),
          avatarUrl: zod.string().nullish(),
          email: zod.string(),
        })
        .optional(),
      location: zod
        .object({
          id: zod.string(),
          gymId: zod.string(),
          name: zod.string(),
          address: zod.string(),
          city: zod.string(),
          state: zod.string(),
          zipCode: zod.string().nullish(),
          phone: zod.string().nullish(),
          timezone: zod.string().nullish(),
          isActive: zod.boolean(),
          isPrimary: zod.boolean(),
          useSharedSchedule: zod.boolean(),
          availabilityMode: zod.enum(["CUSTOM"]),
          createdAt: zod.date(),
        })
        .optional(),
      title: zod.string(),
      description: zod.string().nullish(),
      discipline: zod.string().nullish(),
      level: zod.string().nullish(),
      imageUrl: zod.string().nullish(),
      startTime: zod.date(),
      endTime: zod.date(),
      durationMinutes: zod.number(),
      isRecurring: zod.boolean(),
      capacityLimit: zod.number(),
      enrolledCount: zod.number(),
      waitlistCount: zod.number(),
      price: zod.number(),
      isFree: zod.boolean(),
      mode: zod.enum(["IN_PERSON", "VIDEO"]),
      status: zod.enum(["SCHEDULED", "CANCELLED", "COMPLETED"]),
      createdAt: zod.date(),
    }),
  ),
});

/**
 * @summary Login attack history (blocked IPs per hour)
 */
export const getAdminLoginAttackHistoryQueryHoursDefault = 48;

export const GetAdminLoginAttackHistoryQueryParams = zod.object({
  hours: zod.coerce
    .number()
    .default(getAdminLoginAttackHistoryQueryHoursDefault),
});

export const GetAdminLoginAttackHistoryResponseItem = zod.object({
  windowStart: zod.date(),
  blockedCount: zod.number(),
  totalExpiredCount: zod.number(),
});
export const GetAdminLoginAttackHistoryResponse = zod.array(
  GetAdminLoginAttackHistoryResponseItem,
);

/**
 * @summary Admin calendar events
 */
export const GetAdminCalendarQueryParams = zod.object({
  from: zod.date().optional(),
  to: zod.date().optional(),
  locationId: zod.coerce.string().optional(),
});

export const GetAdminCalendarResponseItem = zod.object({
  id: zod.string(),
  title: zod.string(),
  start: zod.date(),
  end: zod.date(),
  type: zod.enum(["PRIVATE", "CLASS"]),
  status: zod.string(),
  trainerId: zod.string(),
  trainerName: zod.string(),
  studentName: zod.string().nullish(),
  locationName: zod.string().nullish(),
  mode: zod.enum(["IN_PERSON", "VIDEO"]),
});
export const GetAdminCalendarResponse = zod.array(GetAdminCalendarResponseItem);

/**
 * @summary Aggregated trainer availability for calendar
 */
export const GetAdminCalendarTrainerAvailabilityQueryParams = zod.object({
  locationId: zod.coerce.string().optional(),
});

export const GetAdminCalendarTrainerAvailabilityResponseItem = zod.object({
  id: zod.string(),
  trainerId: zod.string(),
  trainerName: zod.string(),
  dayOfWeek: zod.number(),
  startTime: zod.string(),
  endTime: zod.string(),
});
export const GetAdminCalendarTrainerAvailabilityResponse = zod.array(
  GetAdminCalendarTrainerAvailabilityResponseItem,
);

/**
 * @summary Payroll report
 */
export const GetAdminPayrollQueryParams = zod.object({
  from: zod.date().optional(),
  to: zod.date().optional(),
});

export const GetAdminPayrollResponseItem = zod.object({
  trainerId: zod.string(),
  trainerName: zod.string(),
  sessionCount: zod.number(),
  totalRevenue: zod.number(),
  trainerPayout: zod.number(),
  gymRevenue: zod.number(),
});
export const GetAdminPayrollResponse = zod.array(GetAdminPayrollResponseItem);

/**
 * @summary Peak booking hours heatmap
 */
export const GetAnalyticsPeakHoursParams = zod.object({
  gymId: zod.coerce.string(),
});

export const GetAnalyticsPeakHoursQueryParams = zod.object({
  from: zod.coerce.string().optional(),
  to: zod.coerce.string().optional(),
});

export const GetAnalyticsPeakHoursResponse = zod.object({
  heatmap: zod.array(
    zod.object({
      dayOfWeek: zod.number(),
      hour: zod.number(),
      count: zod.number(),
    }),
  ),
});

/**
 * @summary Revenue breakdown
 */
export const GetAnalyticsRevenueBreakdownParams = zod.object({
  gymId: zod.coerce.string(),
});

export const GetAnalyticsRevenueBreakdownQueryParams = zod.object({
  from: zod.coerce.string().optional(),
  to: zod.coerce.string().optional(),
});

export const GetAnalyticsRevenueBreakdownResponse = zod.object({
  totalRevenue: zod.number(),
  platformFees: zod.number(),
  sessionRevenue: zod.number(),
  packageRevenue: zod.number(),
  classRevenue: zod.number(),
  membershipRevenue: zod.number(),
  byMonth: zod.array(
    zod.object({
      month: zod.string(),
      revenue: zod.number(),
    }),
  ),
});

/**
 * @summary Trainer utilization stats
 */
export const GetAnalyticsTrainerUtilizationParams = zod.object({
  gymId: zod.coerce.string(),
});

export const GetAnalyticsTrainerUtilizationResponseItem = zod.object({
  trainerId: zod.string(),
  trainerName: zod.string(),
  availableHours: zod.number(),
  bookedHours: zod.number(),
  utilizationPct: zod.number(),
  avgRating: zod.number().nullish(),
  revenue: zod.number(),
});
export const GetAnalyticsTrainerUtilizationResponse = zod.array(
  GetAnalyticsTrainerUtilizationResponseItem,
);

/**
 * @summary Platform-wide KPIs
 */
export const GetSuperadminDashboardResponse = zod.object({
  totalGyms: zod.number(),
  activeGyms: zod.number(),
  freeGyms: zod.number(),
  premiumGyms: zod.number(),
  totalUsers: zod.number(),
  totalSessions: zod.number(),
  platformRevenue: zod.number(),
  monthlyGrowth: zod.number(),
  topGyms: zod.array(
    zod.object({
      gymId: zod.string(),
      gymName: zod.string(),
      sessionCount: zod.number(),
      revenue: zod.number(),
    }),
  ),
});

/**
 * @summary List all gyms
 */
export const ListAllGymsResponseItem = zod.object({
  id: zod.string(),
  name: zod.string(),
  slug: zod.string(),
  logoUrl: zod.string().nullish(),
  address: zod.string().nullish(),
  timezone: zod.string(),
  isActive: zod.boolean(),
  platformPlan: zod.enum(["FREE", "PREMIUM"]),
  platformFeePerSession: zod.number(),
  pricingMode: zod.enum(["GYM_DEFAULT", "TRAINER_SET", "HYBRID"]),
  defaultHourlyRate: zod.number().nullish(),
  defaultGymSplitPct: zod.number(),
  allowPerTrainerSplit: zod.boolean(),
  trainerMinRate: zod.number().nullish(),
  trainerMaxRate: zod.number().nullish(),
  cancellationWindowHrs: zod.number(),
  refundPctWithinWindow: zod.number(),
  lateRefundPct: zod.number(),
  brandingEnabled: zod.boolean(),
  brandPrimaryColor: zod.string().nullish(),
  brandAccentColor: zod.string().nullish(),
  brandAppName: zod.string().nullish(),
  brandFaviconUrl: zod.string().nullish(),
  brandLogoUrl: zod.string().nullish(),
  customDomain: zod.string().nullish(),
  scheduleSyncEnabled: zod.boolean(),
  aiAssistantName: zod.string().nullish(),
  aiAssistantGender: zod.string().nullish(),
  aiAssistantAvatarUrl: zod.string().nullish(),
  aiAssistantPersonalityPreset: zod.string().nullish(),
  aiAssistantPersonalityCustom: zod.string().nullish(),
  stripeConnectOnboarded: zod.boolean(),
  stripeConnectPayoutsEnabled: zod.boolean(),
  createdAt: zod.date(),
});
export const ListAllGymsResponse = zod.array(ListAllGymsResponseItem);

/**
 * @summary Create gym manually
 */
export const CreateGymAdminBody = zod.object({
  gymName: zod.string(),
  slug: zod.string(),
  address: zod.string().optional(),
  city: zod.string().optional(),
  state: zod.string().optional(),
  zipCode: zod.string().optional(),
  timezone: zod.string().optional(),
  adminEmail: zod.string(),
  adminPassword: zod.string(),
  adminFirstName: zod.string(),
  adminLastName: zod.string(),
  adminPhone: zod.string().optional(),
});

/**
 * @summary Gym detail
 */
export const GetSuperadminGymParams = zod.object({
  id: zod.coerce.string(),
});

export const GetSuperadminGymResponse = zod.object({
  id: zod.string(),
  name: zod.string(),
  slug: zod.string(),
  logoUrl: zod.string().nullish(),
  address: zod.string().nullish(),
  timezone: zod.string(),
  isActive: zod.boolean(),
  platformPlan: zod.enum(["FREE", "PREMIUM"]),
  platformFeePerSession: zod.number(),
  pricingMode: zod.enum(["GYM_DEFAULT", "TRAINER_SET", "HYBRID"]),
  defaultHourlyRate: zod.number().nullish(),
  defaultGymSplitPct: zod.number(),
  allowPerTrainerSplit: zod.boolean(),
  trainerMinRate: zod.number().nullish(),
  trainerMaxRate: zod.number().nullish(),
  cancellationWindowHrs: zod.number(),
  refundPctWithinWindow: zod.number(),
  lateRefundPct: zod.number(),
  brandingEnabled: zod.boolean(),
  brandPrimaryColor: zod.string().nullish(),
  brandAccentColor: zod.string().nullish(),
  brandAppName: zod.string().nullish(),
  brandFaviconUrl: zod.string().nullish(),
  brandLogoUrl: zod.string().nullish(),
  customDomain: zod.string().nullish(),
  scheduleSyncEnabled: zod.boolean(),
  aiAssistantName: zod.string().nullish(),
  aiAssistantGender: zod.string().nullish(),
  aiAssistantAvatarUrl: zod.string().nullish(),
  aiAssistantPersonalityPreset: zod.string().nullish(),
  aiAssistantPersonalityCustom: zod.string().nullish(),
  stripeConnectOnboarded: zod.boolean(),
  stripeConnectPayoutsEnabled: zod.boolean(),
  createdAt: zod.date(),
});

/**
 * @summary Update gym
 */
export const UpdateSuperadminGymParams = zod.object({
  id: zod.coerce.string(),
});

export const UpdateSuperadminGymBody = zod.object({
  name: zod.string().optional(),
  logoUrl: zod.string().optional(),
  address: zod.string().optional(),
  timezone: zod.string().optional(),
});

export const UpdateSuperadminGymResponse = zod.object({
  id: zod.string(),
  name: zod.string(),
  slug: zod.string(),
  logoUrl: zod.string().nullish(),
  address: zod.string().nullish(),
  timezone: zod.string(),
  isActive: zod.boolean(),
  platformPlan: zod.enum(["FREE", "PREMIUM"]),
  platformFeePerSession: zod.number(),
  pricingMode: zod.enum(["GYM_DEFAULT", "TRAINER_SET", "HYBRID"]),
  defaultHourlyRate: zod.number().nullish(),
  defaultGymSplitPct: zod.number(),
  allowPerTrainerSplit: zod.boolean(),
  trainerMinRate: zod.number().nullish(),
  trainerMaxRate: zod.number().nullish(),
  cancellationWindowHrs: zod.number(),
  refundPctWithinWindow: zod.number(),
  lateRefundPct: zod.number(),
  brandingEnabled: zod.boolean(),
  brandPrimaryColor: zod.string().nullish(),
  brandAccentColor: zod.string().nullish(),
  brandAppName: zod.string().nullish(),
  brandFaviconUrl: zod.string().nullish(),
  brandLogoUrl: zod.string().nullish(),
  customDomain: zod.string().nullish(),
  scheduleSyncEnabled: zod.boolean(),
  aiAssistantName: zod.string().nullish(),
  aiAssistantGender: zod.string().nullish(),
  aiAssistantAvatarUrl: zod.string().nullish(),
  aiAssistantPersonalityPreset: zod.string().nullish(),
  aiAssistantPersonalityCustom: zod.string().nullish(),
  stripeConnectOnboarded: zod.boolean(),
  stripeConnectPayoutsEnabled: zod.boolean(),
  createdAt: zod.date(),
});

/**
 * @summary Suspend gym
 */
export const SuspendGymParams = zod.object({
  id: zod.coerce.string(),
});

export const SuspendGymResponse = zod.object({
  id: zod.string(),
  name: zod.string(),
  slug: zod.string(),
  logoUrl: zod.string().nullish(),
  address: zod.string().nullish(),
  timezone: zod.string(),
  isActive: zod.boolean(),
  platformPlan: zod.enum(["FREE", "PREMIUM"]),
  platformFeePerSession: zod.number(),
  pricingMode: zod.enum(["GYM_DEFAULT", "TRAINER_SET", "HYBRID"]),
  defaultHourlyRate: zod.number().nullish(),
  defaultGymSplitPct: zod.number(),
  allowPerTrainerSplit: zod.boolean(),
  trainerMinRate: zod.number().nullish(),
  trainerMaxRate: zod.number().nullish(),
  cancellationWindowHrs: zod.number(),
  refundPctWithinWindow: zod.number(),
  lateRefundPct: zod.number(),
  brandingEnabled: zod.boolean(),
  brandPrimaryColor: zod.string().nullish(),
  brandAccentColor: zod.string().nullish(),
  brandAppName: zod.string().nullish(),
  brandFaviconUrl: zod.string().nullish(),
  brandLogoUrl: zod.string().nullish(),
  customDomain: zod.string().nullish(),
  scheduleSyncEnabled: zod.boolean(),
  aiAssistantName: zod.string().nullish(),
  aiAssistantGender: zod.string().nullish(),
  aiAssistantAvatarUrl: zod.string().nullish(),
  aiAssistantPersonalityPreset: zod.string().nullish(),
  aiAssistantPersonalityCustom: zod.string().nullish(),
  stripeConnectOnboarded: zod.boolean(),
  stripeConnectPayoutsEnabled: zod.boolean(),
  createdAt: zod.date(),
});

/**
 * @summary Activate gym
 */
export const ActivateGymParams = zod.object({
  id: zod.coerce.string(),
});

export const ActivateGymResponse = zod.object({
  id: zod.string(),
  name: zod.string(),
  slug: zod.string(),
  logoUrl: zod.string().nullish(),
  address: zod.string().nullish(),
  timezone: zod.string(),
  isActive: zod.boolean(),
  platformPlan: zod.enum(["FREE", "PREMIUM"]),
  platformFeePerSession: zod.number(),
  pricingMode: zod.enum(["GYM_DEFAULT", "TRAINER_SET", "HYBRID"]),
  defaultHourlyRate: zod.number().nullish(),
  defaultGymSplitPct: zod.number(),
  allowPerTrainerSplit: zod.boolean(),
  trainerMinRate: zod.number().nullish(),
  trainerMaxRate: zod.number().nullish(),
  cancellationWindowHrs: zod.number(),
  refundPctWithinWindow: zod.number(),
  lateRefundPct: zod.number(),
  brandingEnabled: zod.boolean(),
  brandPrimaryColor: zod.string().nullish(),
  brandAccentColor: zod.string().nullish(),
  brandAppName: zod.string().nullish(),
  brandFaviconUrl: zod.string().nullish(),
  brandLogoUrl: zod.string().nullish(),
  customDomain: zod.string().nullish(),
  scheduleSyncEnabled: zod.boolean(),
  aiAssistantName: zod.string().nullish(),
  aiAssistantGender: zod.string().nullish(),
  aiAssistantAvatarUrl: zod.string().nullish(),
  aiAssistantPersonalityPreset: zod.string().nullish(),
  aiAssistantPersonalityCustom: zod.string().nullish(),
  stripeConnectOnboarded: zod.boolean(),
  stripeConnectPayoutsEnabled: zod.boolean(),
  createdAt: zod.date(),
});

/**
 * @summary List all users
 */
export const ListAllUsersResponseItem = zod.object({
  id: zod.string(),
  email: zod.string(),
  firstName: zod.string(),
  lastName: zod.string(),
  role: zod.enum(["SUPERADMIN", "ADMIN", "TRAINER", "STUDENT"]),
  phone: zod.string().nullish(),
  avatarUrl: zod.string().nullish(),
  bio: zod.string().nullish(),
  specialties: zod.array(zod.string()).optional(),
  gymId: zod.string().nullish(),
  primaryLocationId: zod.string().nullish(),
  hourlyRate: zod.number().nullish(),
  gymSplitPct: zod.number().nullish(),
  canSetOwnRate: zod.boolean(),
  smsEnabled: zod.boolean(),
  emailEnabled: zod.boolean(),
  createdAt: zod.date(),
  stripeConnectAccountId: zod.string().nullish(),
  stripeConnectOnboarded: zod.boolean().optional(),
  stripeConnectPayoutsEnabled: zod.boolean().optional(),
  onboardingCompleted: zod.boolean().optional(),
});
export const ListAllUsersResponse = zod.array(ListAllUsersResponseItem);

/**
 * @summary Platform revenue report
 */
export const GetPlatformRevenueResponse = zod.object({
  totalRevenue: zod.number(),
  freeRevenue: zod.number(),
  premiumRevenue: zod.number(),
  subscriptionRevenue: zod.number(),
  byMonth: zod.array(
    zod.object({
      month: zod.string(),
      revenue: zod.number(),
      sessions: zod.number(),
    }),
  ),
});

/**
 * @summary Issue scoped JWT for gym
 */
export const ImpersonateGymParams = zod.object({
  gymId: zod.coerce.string(),
});

export const ImpersonateGymResponse = zod.object({
  token: zod.string(),
});

/**
 * @summary Get Stream Chat token for authenticated user
 */
export const GetChatTokenResponse = zod.object({
  token: zod.string(),
  apiKey: zod.string(),
  userId: zod.string(),
  userName: zod.string(),
});

/**
 * @summary Get chat channels for the authenticated user
 */
export const GetMyChatChannelsResponseItem = zod.object({
  id: zod.string(),
  name: zod.string(),
  memberCount: zod.number(),
  lastMessageAt: zod.string().nullish(),
  sessionId: zod.string().nullish(),
  members: zod.array(
    zod.object({
      userId: zod.string().optional(),
      name: zod.string().optional(),
      role: zod.string().optional(),
      online: zod.boolean().optional(),
    }),
  ),
});
export const GetMyChatChannelsResponse = zod.array(
  GetMyChatChannelsResponseItem,
);

/**
 * @summary Get active chat channels for a gym (admin only)
 */
export const GetGymChatChannelsParams = zod.object({
  gymId: zod.coerce.string(),
});

export const GetGymChatChannelsResponseItem = zod.object({
  id: zod.string(),
  name: zod.string(),
  memberCount: zod.number(),
  lastMessageAt: zod.string().nullish(),
  sessionId: zod.string().nullish(),
  members: zod.array(
    zod.object({
      userId: zod.string().optional(),
      name: zod.string().optional(),
      role: zod.string().optional(),
      online: zod.boolean().optional(),
    }),
  ),
});
export const GetGymChatChannelsResponse = zod.array(
  GetGymChatChannelsResponseItem,
);

/**
 * @summary List student's home gyms
 */
export const GetStudentGymsResponseItem = zod.object({
  id: zod.string(),
  studentId: zod.string(),
  gymId: zod.string(),
  isPrimary: zod.boolean(),
  createdAt: zod.string(),
  gym: zod
    .object({
      id: zod.string(),
      name: zod.string(),
      slug: zod.string(),
      logoUrl: zod.string().nullish(),
      address: zod.string().nullish(),
      trainerCount: zod.number(),
      locationCount: zod.number(),
    })
    .optional(),
});
export const GetStudentGymsResponse = zod.array(GetStudentGymsResponseItem);

/**
 * @summary Add a home gym
 */
export const AddStudentGymBody = zod.object({
  gymId: zod.string(),
});

/**
 * @summary Remove a home gym
 */
export const RemoveStudentGymParams = zod.object({
  gymId: zod.coerce.string(),
});

/**
 * @summary Set a gym as primary
 */
export const SetStudentPrimaryGymParams = zod.object({
  gymId: zod.coerce.string(),
});

export const SetStudentPrimaryGymResponse = zod.object({
  id: zod.string(),
  studentId: zod.string(),
  gymId: zod.string(),
  isPrimary: zod.boolean(),
  createdAt: zod.string(),
  gym: zod
    .object({
      id: zod.string(),
      name: zod.string(),
      slug: zod.string(),
      logoUrl: zod.string().nullish(),
      address: zod.string().nullish(),
      trainerCount: zod.number(),
      locationCount: zod.number(),
    })
    .optional(),
});

/**
 * @summary Get trainer availability across student's home gyms
 */
export const GetStudentMasterCalendarQueryParams = zod.object({
  gymId: zod.coerce.string().optional(),
  locationId: zod.coerce.string().optional(),
});

export const GetStudentMasterCalendarResponse = zod.object({
  trainers: zod
    .array(
      zod.object({
        id: zod.string().optional(),
        firstName: zod.string().optional(),
        lastName: zod.string().optional(),
        avatarUrl: zod.string().nullish(),
        slots: zod
          .array(
            zod.object({
              id: zod.string().optional(),
              dayOfWeek: zod.number().optional(),
              startTime: zod.string().optional(),
              endTime: zod.string().optional(),
              locationId: zod.string().nullish(),
              locationName: zod.string().nullish(),
            }),
          )
          .optional(),
      }),
    )
    .optional(),
  locations: zod
    .array(
      zod.object({
        id: zod.string().optional(),
        name: zod.string().optional(),
        gymId: zod.string().optional(),
      }),
    )
    .optional(),
});
